import React, { useState, useEffect, useCallback, useRef } from 'react'
import './../../App.css';
import './Employees.css';
import { CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import ViewEmployee from './ViewEmployee';
import axios from 'axios';
import {useTable, useSortBy} from 'react-table';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
// icons
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SearchIcon from '@mui/icons-material/Search';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import GroupsIcon from '@mui/icons-material/Groups';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoneIcon from '@mui/icons-material/Done';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import ChecklistIcon from '@mui/icons-material/Checklist';

function EmployeesList({user, userAccess, employeePhoto, setEmployeePhoto, isHideSideMenu}) {
    var header = [
        // "Photo",
        "ID",
        "Full Name",
        "Department",
        "Position",
        "Section",
        "Location",
        // "Date Created",
        // "Is Approved?",
        ""
    ]
    var accessor = [
        // "avatar",
        "employeeId",
        "fullName",
        "employeeInformation.departmentDescription",
        "employeeInformation.positionDescription",
        "employeeInformation.sectionDescription",
        "employeeInformation.locationDescription",
        // "employeeInformationCreatedDate",
        // "employeeInformation.employeeInformationStatus",
        "manage"
    ]
    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showUploadForBulkUpdateForm, setShowUploadForBulkUpdateForm] = useState(false);
    const [showUploadLeaveUpdateForm, setShowUploadLeaveUpdateForm] = useState(false);
    const [showBiometricsListForm, setShowBiometricsListForm] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [selectedToApprove, setSelectedToApprove] = useState([]);
    
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs

    const [classificationFilter, setClassificationFilter] = useState("0");
    const [locationFilter, setLocationFilter] = useState("0");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");
    const [employeeStatus, setEmployeeStatus] = useState("Active");

    // Connect to API
    const [employees, setEmployees] = useState([]);
    // const [employeesBasicInfo, setEmployeesBasicInfo] = useState([]);
    const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("name");
    //ViewEmployee
    const [showViewEmployee, setShowViewEmployee] = useState(false);
    const [viewedData, setViewedData] = useState([]);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    const [showRequestWarningMessage, setShowRequestWarningMessage] = useState(false);
    const [requestWarningMessage, setRequestWarningMessage] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    useEffect(() => {
        if (showRequestWarningMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestWarningMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestWarningMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    function GenerateWarningMessage({form, message}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                    <div className="modal toggleMessage warning-message" style={{backgroundColor: "#ffd0c5"}}>
                        <div className='column'>
                            <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                <ErrorIcon/>
                                <span>{"WARNING MESSAGE"}</span>
                            </div>
                            <span style={{textAlign:"center", padding:"10px 0", color: "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 3:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }
        setEmployees(res);
    }

    const handleUpdate = async () => {
        const apiUrl =  domain + "/api/Employee/update-status/bulk";

        if(selectedEmployee.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Nothing to update.");
            return;
        }

        const data = selectedEmployee.map(_employee => {
            return {
                employeePersonalInformationId: _employee.id,
                status: "Approved"
            };
        })

        try {
            // setLoadingRequest(true);
            await axios.put(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            // Reload table data and reset form fields
            await fetchDataBasicInfo();
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
            setActiveRowIds([]);
            setSelectedEmployee([]);
        } catch (error) {
            // setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    const apiUrl =  domain + "/api/Employee/";

    const fetchDataEmployeeInfoForMasterlist = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/masterlist";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);
    const fetchDataEmployeeInformationOnly = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/employee-information-only";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);
    const fetchDataEmployeeById = useCallback(async (id) => {
        try {
            const response = await axios.get(apiUrl + `${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [apiUrl]);

    const fetchDataBasicInfo = useCallback(async () => {
        setLoading(true);

        try {
            const response = await axios.get(apiUrl + `single-data/status/${employeeStatus}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})

            let _filteredData = response.data;

            if(filterDataIndex === 2){ //Approved Employees
                const approvedEmployees = response.data.filter(employee => {
                    return employee.employeeInformation.employeeInformationStatus === "Approved"
                });

                _filteredData = approvedEmployees;
            } else if(filterDataIndex === 3){ //Pending Employees
                const pendingEmployees = response.data.filter(employee => {
                    return employee.employeeInformation.employeeInformationStatus !== "Approved"
                });

                _filteredData = pendingEmployees;
            }

            setAllEmployeesBasicInfo(_filteredData);
            setEmployees(_filteredData);
            setFilterData(_filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [apiUrl, 
        filterDataIndex,
        employeeStatus
    ]);

    useEffect(()=>{
        let classifiedData = allEmployeesBasicInfo;
        let classificiationFilter = classificationFilter;

        setCurrentClassificationFilter(classificiationFilter);

        if(classificiationFilter !== "0"){
            const _classified = allEmployeesBasicInfo.filter(employee => {
                
                if (employee.employeeInformation && employee.employeeInformation.classificationId) {
                    return employee.employeeInformation.classificationId.toString() === classificiationFilter;
                }
                return false;
            });
            
            classifiedData = _classified;
        }

        let filteredBySection = classifiedData;

        if(locationFilter !== "0"){
            filteredBySection = classifiedData.filter(i => i.employeeInformation?.locationId?.toString() === locationFilter?.toString())
            console.log(filteredBySection)
        }

        if(classificiationFilter !== currentClassificationFilter )
        {
            setLocationFilter("0");
        }
        
        setEmployees(filteredBySection);
        setFilterData(filteredBySection);
    }, [
        classificationFilter, 
        locationFilter,
        currentClassificationFilter,
        allEmployeesBasicInfo,
    ])

    useEffect(() => {
        fetchDataBasicInfo();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("name");
                break;
            case 1:
                setSearchPlaceholder("employee id");
                break;
            case 2:
                setSearchPlaceholder("name");
                break;
            case 3:
                setSearchPlaceholder("name");
                break;
            default:
                setSearchPlaceholder("name");
                break;
        }
    }, [fetchDataBasicInfo, filterDataIndex]);

    const addHandleClick = () =>{
        window.location.pathname = "/addEmployee";
    }
    const viewEmployeeHandleClick = async (data) =>{
        setLoading(true);

        const employeeInfo = await fetchDataEmployeeById(data.id);
        setViewedData(employeeInfo);
        
        setLoading(false);
        setShowViewEmployee(true);
    }
    const closeViewEmployeeHandleClick = () =>{
        setShowViewEmployee(false);
    }

    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }
    const openUploadForBulkUpdateEmployeeInformationFormHandleClick  = () =>{
        setShowUploadForBulkUpdateForm(true);
    }
    const closeUploadForBulkUpdateEmployeeInformationFormHandleClick = () =>{
        setShowUploadForBulkUpdateForm(false);
    }
    const openBiometricsListFormHandleClick  = () =>{
        setShowBiometricsListForm(true);
    }
    const closeBiometricsListFormHandleClick = () =>{
        setShowBiometricsListForm(false);
    }
    const openUploadLeaveFormHandleClick  = () =>{
        setShowUploadLeaveUpdateForm(true);
    }
    const closeUploadLeaveFormHandleClick = () =>{
        setShowUploadLeaveUpdateForm(false);
    }

    var newLeave = true

    const fetchDataLeaveTypes = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/LeaveType/active`, {
            headers: { 'Content-Type': 'application/json' }
            });

            return (response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            return []
        }
    }, []);

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeePersonalInformation');
        const worksheet2 = workbook.addWorksheet('EmployeeInformation');
        const worksheet3 = workbook.addWorksheet('AccountInformation');
        const worksheet4 = workbook.addWorksheet('BankAccount');
        const worksheet5 = workbook.addWorksheet('EmployeeSalary');
        const worksheet6 = workbook.addWorksheet('Dependents');
        const worksheet7 = workbook.addWorksheet('EducationalAttainment');
        const worksheet8 = workbook.addWorksheet('EmergencyContact');
        const worksheet9 = workbook.addWorksheet('FamilyData');
        const worksheet10 = workbook.addWorksheet('EmployeeLeaves');
        const worksheet11 = workbook.addWorksheet('EmployeeStatus');

        //EmployeePersonalInformation
        const headerEmployeePersonalInformation = [
            'EmployeeId',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'NickName',
            'Age',
            'DateOfBirth',
            'PlaceOfBirth',
            'CivilStatus',
            'BloodType',
            'Height',
            'Weight',
            'Citizenship',
            'Religion',
            'Gender',
            'MobileNumber',
            'EmailAddress',
            'BlkLot',
            'Street',
            'Barangay',
            'City',
            'PostalCode',
            'YearsOfStay',
            'DeviceNumber',
        ];
        const headerRowEmployeePersonalInformation = worksheet1.addRow(headerEmployeePersonalInformation);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'nickname', width: 20 },
            { key: 'age', width: 10 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'placeOfBirth', width: 30 },
            { key: 'civilStatus', width: 20 },
            { key: 'bloodType', width: 10 },
            { key: 'height', width: 10 },
            { key: 'weight', width: 10 },
            { key: 'citizenship', width: 20 },
            { key: 'religion', width: 20 },
            { key: 'gender', width: 10 },
            { key: 'mobileNumber', width: 20 },
            { key: 'emailAddress', width: 30 },
            { key: 'blkLot', width: 20 },
            { key: 'street', width: 30 },
            { key: 'barangay', width: 20 },
            { key: 'city', width: 20 },
            { key: 'postalCode', width: 15 },
            { key: 'yearsOfStay', width: 15 },
            { key: 'deviceNumber', width: 15 },
        ];
        headerRowEmployeePersonalInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeePersonalInformation = [
            {
                employeeId: '<EMP1234>',
                lastName: '<DELA CRUZ>',
                firstName: '<JUAN>',
                middleName: '<ANTONIO>',
                extensionName: '<OPTIONAL>',
                nickname: '<OPTIONAL>',
                age: '<30>',
                dateOfBirth: '<01/01/1993>',
                placeOfBirth: '<CALOOCAN CITY>',
                civilStatus: '<SINGLE>',
                bloodType: 'OPTIONAL',
                height: '<OPTIONAL>',
                weight: '<OPTIONAL>',
                citizenship: '<FILIPINO>',
                religion: '<ROMAN CATHOLIC>',
                gender: '<MALE>',
                mobileNumber: '<09123456789>',
                emailAddress: '<JUANDELACRUZ@GMAIL.COM>',
                blkLot: '<BLK 123 LOT 456>',
                street: '<JUAN LUNA STREET>',
                barangay: '<DEPARO>',
                city: '<CALOOCAN CITY>',
                postalCode: '<1420>',
                yearsOfStay: '<5>',
                deviceNumber: '<0000>',
            },
        ];

        employeeDataEmployeePersonalInformation.forEach(employee => {
            worksheet1.addRow(employee);
        });

        //EmployeeInformation
        const headerEmployeeInformation = [
            'EmployeeId',
            'Location',
            'DateEmployed',
            'DateRegular',
            'DateProbationary',
            'DateResigned',
            'DateContractual',
            'EmploymentDuration',
            'Employment',
            'Department',
            'Section',
            'Classification',
            'PayType',
            'ShiftSchedule',
            'Position',
            'Company',
            'SalaryType',
        ];
        const headerRowEmployeeInformation = worksheet2.addRow(headerEmployeeInformation);
        worksheet2.columns = [
            { key: 'employeeId', width: 20 },
            { key: 'location', width: 30 },
            { key: 'dateEmployed', width: 20 },
            { key: 'dateRegular', width: 20 },
            { key: 'dateProbationary', width: 20 },
            { key: 'dateResigned', width: 20 },
            { key: 'dateContractual', width: 20 },
            { key: 'employmentDuration', width: 25 },
            { key: 'employment', width: 25 },
            { key: 'department', width: 30 },
            { key: 'section', width: 30 },
            { key: 'classification', width: 20 },
            { key: 'payType', width: 20 },
            { key: 'shiftSchedule', width: 20 },
            { key: 'position', width: 30 },
            { key: 'company', width: 30 },
            { key: 'salaryType', width: 30 },
        ];
        headerRowEmployeeInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeInformation = [
            {
                employeeId: '<EMP1234>',
                location: '<MAIN OFFICE>',
                dateEmployed: '<01-01-2021>',
                dateRegular: '<OPTIONAL>',
                dateProbationary: '<OPTIONAL>',
                dateResigned: '<OPTIONAL>',
                dateContractual: '<OPTIONAL>',
                employmentDuration: '<OPTIONAL>',
                employment: '<REGULAR>',
                department: '<IT>',
                section: '<SOFTWARE DEVELOPER>',
                classification: '<OFFICE>',
                payType: '<SEMI-MONTHLY>',
                shiftSchedule: '<MORNING SHIFT>',
                position: '<APPLICATION DEVELOPER>',
                company: '<COMPANY NAME>',
                salaryType: '<DAILY>',
            }
        ];

        employeeDataEmployeeInformation.forEach(employee => {
            worksheet2.addRow(employee);
        });

        //AccountInformation
        const headerAccountInformation = [
            'EmployeeId',
            'Sss',
            'Tin',
            'Passport',
            'Philhealth',
            'Pagibig'
        ];
        const headerRowAccountInformation = worksheet3.addRow(headerAccountInformation);
        worksheet3.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'sss', width: 30 },
            { key: 'tin', width: 30 },
            { key: 'passport', width: 30 },
            { key: 'philhealth', width: 30 },
            { key: 'pagibig', width: 30 },
        ];
        headerRowAccountInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataAccountInformation = [
            {
                employeeId: '<EMP1234>',
                sss: '<00-00000000-0>',
                tin: '<000-000-000-000>',
                passport: '<OPTIONAL>',
                philhealth: '<00-000000000-0>',
                pagibig: '<0000-0000-0000>',
            }
        ];

        employeeDataAccountInformation.forEach(employee => {
            worksheet3.addRow(employee);
        });

        //BankAccount
        const headerBankAccount = [
            'EmployeeId',
            'BankAccount',
            'BankName'
        ];
        const headerRowBankAccount = worksheet4.addRow(headerBankAccount);
        worksheet4.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'bankAccount', width: 30 },
            { key: 'bankName', width: 30 },
        ];
        headerRowBankAccount.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataBankAccount = [
            {
                employeeId: '<EMP1234>',
                bankAccount: '<0000000000000>',
                bankName: '<BPI>',
            }
        ];

        employeeDataBankAccount.forEach(employee => {
            worksheet4.addRow(employee);
        });

        //EmployeeSalary
        const headerEmployeeSalary = [
            'EmployeeId',
            'Salary',
            'Allowance'
        ];
        const headerRowEmployeeSalary = worksheet5.addRow(headerEmployeeSalary);
        worksheet5.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'allowance', width: 30 },
        ];
        headerRowEmployeeSalary.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeSalary = [
            {
                employeeId: '<EMP1234>',
                salary: '<#,##0.00>',
                allowance: '<#,##0.00>',
            }
        ];

        employeeDataEmployeeSalary.forEach(employee => {
            worksheet5.addRow(employee);
        });
        
        //Dependents
        const headerDependents = [
            'EmployeeId',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'DateOfBirth',
            'Gender',
            'CivilStatus'
        ];
        const headerRowDependents = worksheet6.addRow(headerDependents);
        worksheet6.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'gender', width: 20 },
            { key: 'civilStatus', width: 20 },
        ];
        headerRowDependents.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataDependents = [
            {
                employeeId: '<EMP1234>',
                lastName: '<DELA CRUZ>',
                firstName: '<JUNIOR>',
                middleName: '<ANTONIO>',
                extensionName: '<OPTIONAL>',
                dateOfBirth: '<01/01/2021>',
                gender: '<MALE>',
                civilStatus: '<SINGLE>',
            }
        ];

        employeeDataDependents.forEach(employee => {
            worksheet6.addRow(employee);
        });

        //EducationalAttainment
        const headerEducationalAttainment = [
            'EmployeeId',
            'Level',
            'SchoolName',
            'Address',
            'DateFrom',
            'DateTo',
            'Course',
            'Honors'
        ];
        const headerRowEducationalAttainment = worksheet7.addRow(headerEducationalAttainment);
        worksheet7.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'level', width: 30 },
            { key: 'schoolName', width: 30 },
            { key: 'address', width: 30 },
            { key: 'dateFrom', width: 30 },
            { key: 'dateTo', width: 30 },
            { key: 'course', width: 30 },
            { key: 'honors', width: 30 },
        ];
        headerRowEducationalAttainment.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEducationalAttainment = [
            {
                employeeId: '<EMP1234>',
                level: '<PRIMARY>',
                schoolName: '<UNIVERSITY OF THE PHILIPPINES>',
                address: '<QUEZON CITY>',
                dateFrom: '<01/01/2021>',
                dateTo: '<01/01/2021>',
                course: '<NONE>',
                honors: '<NONE>',
            }
        ];

        employeeDataEducationalAttainment.forEach(employee => {
            worksheet7.addRow(employee);
        });

        //EmergencyContact
        const headerEmergencyContact = [
            'EmployeeId',
            'Name',
            'Relationship',
            'ContactNumber',
            'Address'
        ];
        const headerRowEmergencyContact = worksheet8.addRow(headerEmergencyContact);
        worksheet8.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'name', width: 30 },
            { key: 'relationship', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'address', width: 30 },
        ];
        headerRowEmergencyContact.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmergencyContact = [
            {
                employeeId: '<EMP1234>',
                name: '<DELA CRUZ, SPOUSE>',
                relationship: '<SPOUSE>',
                contactNumber: '<09123456789>',
                address: '<CALOOCAN CITY>',
            }
        ];

        employeeDataEmergencyContact.forEach(employee => {
            worksheet8.addRow(employee);
        });

        //FamilyData
        const headerFamilyData = [
            'EmployeeId',
            'Name',
            'DateOfBirth',
            'Occupation',
            'ContactNumber',
            'Age',
            'Address',
            'Relationship'
        ];
        const headerRowFamilyData = worksheet9.addRow(headerFamilyData);
        worksheet9.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'name', width: 30 },
            { key: 'dateOfBirth', width: 30 },
            { key: 'occupation', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'age', width: 30 },
            { key: 'address', width: 20 },
            { key: 'relationship', width: 10 },
        ];
        headerRowFamilyData.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataFamilyData = [
            {
                employeeId: '<EMP1234>',
                name: '<DELA CRUZ, SPOUSE>',
                dateOfBirth: '<01/01/2021>',
                occupation: '<NONE>',
                contactNumber: '<09123456789>',
                age: '<25>',
                address: '<CALOOCAN CITY>',
                relationship: '<SPOUSE>',
            }
        ];

        employeeDataFamilyData.forEach(employee => {
            worksheet9.addRow(employee);
        });

        if(newLeave){
            const dataLeaveTypes = await fetchDataLeaveTypes();

            const leaveTypeList = dataLeaveTypes.map(i => i.description);

            //EmployeeLeaves
            const headerEmployeeLeaves = [
                'EmployeeId',
                'LeaveType',
                'InitialValue',
                'RemainingValue',
                'Q1Value(Jan-Mar)',
                'Q2Value(Apr-Jun)',
                'Q3Value(Jul-Sep)',
                'Q4Value(Oct-Dec)',
            ];
            const headerRowEmployeeLeaves = worksheet10.addRow(headerEmployeeLeaves);
            worksheet10.columns = [
                { key: 'employeeId', width: 30 },
                { key: 'leaveType', width: 30 },
                { key: 'initialValue', width: 30 },
                { key: 'remainingValue', width: 30 },
                { key: 'q1Value', width: 30 },
                { key: 'q2Value', width: 30 },
                { key: 'q3Value', width: 30 },
                { key: 'q4Value', width: 30 },
            ];
            headerRowEmployeeLeaves.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '92d050' },
                };
            });

            for (let i = 2; i <= 1000; i++) {
                worksheet10.getCell(`B${i}`).dataValidation = {
                    type: "list",
                    allowBlank: true,
                    formulae: [`"${leaveTypeList.join(',')}"`],
                    showErrorMessage: true,
                    errorStyle: "error",
                    errorTitle: "Invalid Leave Type",
                    error: "Please select a valid Leave Type from dropdown.",
                };
            }

            const employeeDataEmployeeLeave = [
                {
                    employeeId: '<EMP1234>',
                    leaveType: '<Sick Leave>',
                    initialVaue: '<10.00>',
                    remainingValue: '<10.00>',
                    q1Value: '<10.00>',
                    q2Value: '<10.00>',
                    q3Value: '<10.00>',
                    q4Value: '<10.00>',
                }
            ];

            employeeDataEmployeeLeave.forEach(employee => {
                worksheet10.addRow(employee);
            });
        } else {
            //EmployeeLeaves
            const headerEmployeeLeaves = [
                'EmployeeId',
                'VacationLeave',
                'SickLeave',
                'ServiceIncentiveLeave',
                'SoloParentLeave',
                'VacationLeaveRemaining',
                'SickLeaveRemaining',
                'ServiceIncentiveLeaveRemaining',
                'SoloParentLeaveRemaining',
            ];
            const headerRowEmployeeLeaves = worksheet10.addRow(headerEmployeeLeaves);
            worksheet10.columns = [
                { key: 'employeeId', width: 30 },
                { key: 'totalVacation', width: 30 },
                { key: 'totalSick', width: 30 },
                { key: 'totalServiceIncentive', width: 30 },
                { key: 'totalSoloParent', width: 30 },
                { key: 'vacationRemaining', width: 30 },
                { key: 'sickRemaining', width: 30 },
                { key: 'serviceIncentiveRemaining', width: 30 },
                { key: 'soloParentRemaining', width: 30 },
            ];
            headerRowEmployeeLeaves.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '92d050' },
                };
            });

            const employeeDataEmployeeLeave = [
                {
                    employeeId: '<EMP1234>',
                    totalVacation: '<10.00>',
                    totalSick: '<10.00>',
                    totalServiceIncentive: '<10.00>',
                    totalSoloParent: '<10.00>',
                    vacationRemaining: '<10.00>',
                    sickRemaining: '<10.00>',
                    serviceIncentiveRemaining: '<10.00>',
                    soloParentRemaining: '<10.00>',
                }
            ];

            employeeDataEmployeeLeave.forEach(employee => {
                worksheet10.addRow(employee);
            });
        }

        //EmployeeStatus
        const headerEmployeeStatus = [
            'EmployeeId',
            'EmployeeStatus',
        ];
        const headerRowEmployeeStatus = worksheet11.addRow(headerEmployeeStatus);
        worksheet11.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'status', width: 30 },
        ];
        headerRowEmployeeStatus.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const employeeDataEmployeeStatus = [
            {
                employeeId: '<EMP1234>',
                status: '<Active>',
            }
        ];

        employeeDataEmployeeStatus.forEach(employee => {
            worksheet11.addRow(employee);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Template.xlsx');
    }, [newLeave, fetchDataLeaveTypes]);
    const generateDownloadMasterlist = useCallback(async () => {
        setLoadingRequest(true);

        const _employees = await fetchDataEmployeeInfoForMasterlist();
        if(_employees && _employees.length <= 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please wait for the _employees to load");
            return;
        }
    
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeePersonalInformation');
        const worksheet2 = workbook.addWorksheet('EmployeeInformation');
        const worksheet3 = workbook.addWorksheet('AccountInformation');
        const worksheet4 = workbook.addWorksheet('BankAccount');
        const worksheet5 = workbook.addWorksheet('EmployeeSalary');
        const worksheet6 = workbook.addWorksheet('Dependents');
        const worksheet7 = workbook.addWorksheet('EducationalAttainment');
        const worksheet8 = workbook.addWorksheet('EmergencyContact');
        const worksheet9 = workbook.addWorksheet('FamilyData');
        const worksheet10 = workbook.addWorksheet('EmployeeLeaves');
        const worksheet11 = workbook.addWorksheet('EmployeeStatus');
    
        function formatDate(dateString) {
            if(!dateString){
                return '';
            }
            const date = new Date(dateString);
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
            const day = String(date.getDate()).padStart(2, '0');
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        }
    
        //EmployeePersonalInformation
        const headerEmployeePersonalInformation = [
            'EmployeeId',
            'EmployeeName',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'NickName',
            'Age',
            'DateOfBirth',
            'PlaceOfBirth',
            'CivilStatus',
            'BloodType',
            'Height',
            'Weight',
            'Citizenship',
            'Religion',
            'Gender',
            'MobileNumber',
            'EmailAddress',
            'BlkLot',
            'Street',
            'Barangay',
            'City',
            'PostalCode',
            'YearsOfStay',
            'DeviceNumber',
        ];
        const headerRowEmployeePersonalInformation = worksheet1.addRow(headerEmployeePersonalInformation);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'nickname', width: 20 },
            { key: 'age', width: 10 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'placeOfBirth', width: 30 },
            { key: 'civilStatus', width: 20 },
            { key: 'bloodType', width: 10 },
            { key: 'height', width: 10 },
            { key: 'weight', width: 10 },
            { key: 'citizenship', width: 20 },
            { key: 'religion', width: 20 },
            { key: 'gender', width: 10 },
            { key: 'mobileNumber', width: 20 },
            { key: 'emailAddress', width: 30 },
            { key: 'blkLot', width: 20 },
            { key: 'street', width: 30 },
            { key: 'barangay', width: 20 },
            { key: 'city', width: 20 },
            { key: 'postalCode', width: 15 },
            { key: 'yearsOfStay', width: 15 },
            { key: 'deviceNumber', width: 15 },
        ];
        headerRowEmployeePersonalInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach((item) => {
            worksheet1.addRow([
                item.employeeId,
                item.fullName,
                item.lastName,
                item.firstName,
                item.middleName,
                item.extensionName,
                item.nickName,
                item.age,
                formatDate(item.dateOfBirth),
                item.placeOfBirth,
                item.civilStatus,
                item.bloodType,
                item.height,
                item.weight,
                item.citizenship,
                item.religion,
                item.gender,
                item.mobileNumber,
                item.emailAddress,
                item.blkLot,
                item.street,
                item.barangay,
                item.city,
                item.postalCode,
                item.yearsOfStay,
                item.deviceNumber,
            ]);
        });
    
        //EmployeeInformation
        const headerEmployeeInformation = [
            'EmployeeId',
            'EmployeeName',
            'Location',
            'DateEmployed',
            'DateRegular',
            'DateProbationary',
            'DateResigned',
            'DateContractual',
            'EmploymentDuration',
            'Employment',
            'Department',
            'Section',
            'Classification',
            'PayType',
            'ShiftSchedule',
            'Position',
            'Company',
            'SalaryType'
        ];
        const headerRowEmployeeInformation = worksheet2.addRow(headerEmployeeInformation);
        worksheet2.columns = [
            { key: 'employeeId', width: 20 },
            { key: 'fullName', width: 20 },
            { key: 'location', width: 30 },
            { key: 'dateEmployed', width: 20 },
            { key: 'dateRegular', width: 20 },
            { key: 'dateProbationary', width: 20 },
            { key: 'dateResigned', width: 20 },
            { key: 'dateContractual', width: 20 },
            { key: 'employmentDuration', width: 25 },
            { key: 'employment', width: 25 },
            { key: 'department', width: 30 },
            { key: 'section', width: 30 },
            { key: 'classification', width: 20 },
            { key: 'payType', width: 20 },
            { key: 'shiftSchedule', width: 20 },
            { key: 'position', width: 30 },
            { key: 'company', width: 30 },
            { key: 'salaryType', width: 30 },
        ];
        headerRowEmployeeInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        // console.log(_employees)
    
        _employees.forEach(item => {
            if(item.employeeInformation){
                worksheet2.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeInformation.locationDescription ? item.employeeInformation.locationDescription : "",
                    item.employeeInformation.dateEmployed ? item.employeeInformation.dateEmployed : "",
                    item.employeeInformation.dateRegular ? item.employeeInformation.dateRegular : "",
                    item.employeeInformation.dateProbationary ? item.employeeInformation.dateProbationary : "",
                    item.employeeInformation.dateResigned ? item.employeeInformation.dateResigned : "",
                    item.employeeInformation.dateContractual ? item.employeeInformation.dateContractual : "",
                    item.employeeInformation.employmentDuration ? item.employeeInformation.employmentDuration : "",
                    item.employeeInformation.employmentDescription ? item.employeeInformation.employmentDescription : "",
                    item.employeeInformation.departmentDescription ? item.employeeInformation.departmentDescription : "",
                    item.employeeInformation.sectionDescription ? item.employeeInformation.sectionDescription : "",
                    item.employeeInformation.classificationDescription ? item.employeeInformation.classificationDescription : "",
                    item.employeeInformation.payTypeDescription ? item.employeeInformation.payTypeDescription : "",
                    item.employeeInformation.shiftScheduleShiftName ? item.employeeInformation.shiftScheduleShiftName : "",
                    item.employeeInformation.positionDescription ? item.employeeInformation.positionDescription : "",
                    item.employeeInformation.companyName ? item.employeeInformation.companyName : "",
                    item.employeeInformation.salaryType ? item.employeeInformation.salaryType : "",
                ]);
            }
            else{
                worksheet2.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //AccountInformation
        const headerAccountInformation = [
            'EmployeeId',
            'EmployeeName',
            'Sss',
            'Tin',
            'Passport',
            'Philhealth',
            'Pagibig'
        ];
        const headerRowAccountInformation = worksheet3.addRow(headerAccountInformation);
        worksheet3.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'sss', width: 30 },
            { key: 'tin', width: 30 },
            { key: 'passport', width: 30 },
            { key: 'philhealth', width: 30 },
            { key: 'pagibig', width: 30 },
        ];
        headerRowAccountInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeAccountInformation){
                worksheet3.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeAccountInformation.sss ? item.employeeAccountInformation.sss : "",
                    item.employeeAccountInformation.tin ? item.employeeAccountInformation.tin : "",
                    item.employeeAccountInformation.passport ? item.employeeAccountInformation.passport : "",
                    item.employeeAccountInformation.philhealth ? item.employeeAccountInformation.philhealth : "",
                    item.employeeAccountInformation.pagibig ? item.employeeAccountInformation.pagibig : "",
                ]);
            }
            else{
                worksheet3.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //BankAccount
        const headerBankAccount = [
            'EmployeeId',
            'EmployeeName',
            'BankAccount',
            'BankName'
        ];
        const headerRowBankAccount = worksheet4.addRow(headerBankAccount);
        worksheet4.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'bankAccount', width: 30 },
            { key: 'bankName', width: 30 },
        ];
        headerRowBankAccount.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeBankAccount && item.employeeBankAccount.length > 0) {
                item.employeeBankAccount.forEach(account => {
                    worksheet4.addRow([
                        item.employeeId,
                        item.fullName,
                        account.bankAccount ? account.bankAccount : "",
                        account.bankName ? account.bankName : ""
                    ]);
                });
            } else {
                worksheet4.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EmployeeSalary
        const headerEmployeeSalary = [
            'EmployeeId',
            'EmployeeName',
            'Salary',
            'Allowance'
        ];
        const headerRowEmployeeSalary = worksheet5.addRow(headerEmployeeSalary);
        worksheet5.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'salary', width: 30 },
            { key: 'allowance', width: 30 },
        ];
        headerRowEmployeeSalary.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeSalary){
                worksheet5.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeSalary.salary ? item.employeeSalary.salary : "",
                    item.employeeSalary.allowance ? item.employeeSalary.allowance : "",
                ]);
            } else {
                worksheet5.addRow([item.employeeId, item.fullName]);
            }
        });
        
        //Dependents
        const headerDependents = [
            'EmployeeId',
            'EmployeeName',
            'LastName',
            'FirstName',
            'MiddleName',
            'ExtensionName',
            'DateOfBirth',
            'Gender',
            'CivilStatus'
        ];
        const headerRowDependents = worksheet6.addRow(headerDependents);
        worksheet6.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'lastName', width: 30 },
            { key: 'firstName', width: 30 },
            { key: 'middleName', width: 30 },
            { key: 'extensionName', width: 30 },
            { key: 'dateOfBirth', width: 20 },
            { key: 'gender', width: 20 },
            { key: 'civilStatus', width: 20 },
        ];
        headerRowDependents.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeDependents && item.employeeDependents.length > 0) {
                item.employeeDependents.forEach(dependent => {
                    worksheet6.addRow([
                        item.employeeId,
                        item.fullName,
                        dependent.lastName ? dependent.lastName : "",
                        dependent.firstName ? dependent.firstName : "",
                        dependent.middleName ? dependent.middleName : "",
                        dependent.extensionName ? dependent.extensionName : "",
                        dependent.dateOfBirth ? formatDate(dependent.dateOfBirth) : "",
                        dependent.gender ? dependent.gender : "",
                        dependent.civilStatus ? dependent.civilStatus : ""
                    ]);
                });
            } else {
                worksheet6.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EducationalAttainment
        const headerEducationalAttainment = [
            'EmployeeId',
            'EmployeeName',
            'Level',
            'SchoolName',
            'Address',
            'DateFrom',
            'DateTo',
            'Course',
            'Honors'
        ];
        const headerRowEducationalAttainment = worksheet7.addRow(headerEducationalAttainment);
        worksheet7.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'level', width: 30 },
            { key: 'schoolName', width: 30 },
            { key: 'address', width: 30 },
            { key: 'dateFrom', width: 30 },
            { key: 'dateTo', width: 30 },
            { key: 'course', width: 30 },
            { key: 'honors', width: 30 },
        ];
        headerRowEducationalAttainment.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeEducationAttainments && item.employeeEducationAttainments.length > 0) {
                item.employeeEducationAttainments.forEach(data => {
                    worksheet7.addRow([
                        item.employeeId,
                        item.fullName,
                        data.level ? data.level : "",
                        data.schoolName ? data.schoolName : "",
                        data.address ? data.address : "",
                        data.dateFrom ? formatDate(data.dateFrom) : "",
                        data.dateTo ? formatDate(data.dateTo) : "",
                        data.course ? data.course : "",
                        data.honors ? data.honors : "",
                    ]);
                });
            } else {
                worksheet7.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //EmergencyContact
        const headerEmergencyContact = [
            'EmployeeId',
            'EmployeeName',
            'Name',
            'Relationship',
            'ContactNumber',
            'Address'
        ];
        const headerRowEmergencyContact = worksheet8.addRow(headerEmergencyContact);
        worksheet8.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'name', width: 30 },
            { key: 'relationship', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'address', width: 30 },
        ];
        headerRowEmergencyContact.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeEmergencyContacts && item.employeeEmergencyContacts.length > 0) {
                item.employeeEmergencyContacts.forEach(data => {
                    worksheet8.addRow([
                        item.employeeId,
                        item.fullName,
                        data.name ? data.name : "",
                        data.relationship ? data.relationship : "",
                        data.contactNumber ? data.contactNumber : "",
                        data.address ? data.address : "",
                    ]);
                });
            } else {
                worksheet8.addRow([item.employeeId, item.fullName]);
            }
        });
    
        //FamilyData
        const headerFamilyData = [
            'EmployeeId',
            'EmployeeName',
            'Name',
            'DateOfBirth',
            'Occupation',
            'ContactNumber',
            'Age',
            'Address',
            'Relationship'
        ];
        const headerRowFamilyData = worksheet9.addRow(headerFamilyData);
        worksheet9.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'name', width: 30 },
            { key: 'dateOfBirth', width: 30 },
            { key: 'occupation', width: 30 },
            { key: 'contactNumber', width: 30 },
            { key: 'age', width: 30 },
            { key: 'address', width: 20 },
            { key: 'relationship', width: 20 },
        ];
        headerRowFamilyData.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if (item.employeeFamilyData && item.employeeFamilyData.length > 0) {
                item.employeeFamilyData.forEach(data => {
                    worksheet9.addRow([
                        item.employeeId,
                        item.fullName,
                        data.name ? data.name : "",
                        data.dateOfBirth ? formatDate(data.dateOfBirth) : "",
                        data.occupation ? data.occupation : "",
                        data.contactNumber ? data.contactNumber : "",
                        data.age ? data.age : "",
                        data.address ? data.address : "",
                        data.relationship ? data.relationship : "",
                    ]);
                });
            } else {
                worksheet9.addRow([item.employeeId, item.fullName]);
            }
        });
    
        if(newLeave){
            const headerEmployeeLeaves = [
                'EmployeeId',
                'EmployeeName',
                'LeaveType',
                'InitialValue',
                'RemainingValue',
                'Q1Value(Jan-Mar)',
                'Q2Value(Apr-Jun)',
                'Q3Value(Jul-Sep)',
                'Q4Value(Oct-Dec)',
            ];
            const headerRowEmployeeLeaves = worksheet10.addRow(headerEmployeeLeaves);
            worksheet10.columns = [
                { key: 'employeeId', width: 30 },
                { key: 'fullName', width: 30 },
                { key: 'leaveTypeDescription', width: 30 },
                { key: 'initialValue', width: 30 },
                { key: 'remainingValue', width: 30 },
                { key: 'q1Value', width: 30 },
                { key: 'q2Value', width: 30 },
                { key: 'q3Value', width: 20 },
                { key: 'q4Value', width: 20 },
            ];
            headerRowEmployeeLeaves.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '92d050' },
                };
            });
        
            _employees.forEach(item => {
                if (item.employeeLeaveInformation && item.employeeLeaveInformation.length > 0) {
                    item.employeeLeaveInformation.forEach(data => {
                        worksheet10.addRow([
                            item.employeeId,
                            item.fullName,
                            data.leaveTypeDescription ? data.leaveTypeDescription : "",
                            data.initialValue ? data.initialValue : "",
                            data.remainingValue ? data.remainingValue : "",
                            data.q1Value ? data.q1Value : "",
                            data.q2Value ? data.q2Value : "",
                            data.q3Value ? data.q3Value : "",
                            data.q4Value ? data.q4Value : "",
                        ]);
                    });
                } else {
                    worksheet10.addRow([item.employeeId, item.fullName]);
                }
            });
        } else {
            //EmployeeLeave
            const headerEmployeeLeaves = [
                'EmployeeId',
                'EmployeeName',
                'VacationLeave',
                'SickLeave',
                'ServiceIncentiveLeave',
                'SoloParentLeave',
                'VacationLeaveRemaining',
                'SickLeaveRemaining',
                'ServiceIncentiveLeaveRemaining',
                'SoloParentLeaveRemaining',
            ];
            const headerRowEmployeeLeaves = worksheet10.addRow(headerEmployeeLeaves);
            worksheet10.columns = [
                { key: 'employeeId', width: 30 },
                { key: 'fullName', width: 30 },
                { key: 'totalVacation', width: 30 },
                { key: 'totalSick', width: 30 },
                { key: 'totalServiceIncentive', width: 30 },
                { key: 'totalSoloParent', width: 30 },
                { key: 'vacationRemaining', width: 30 },
                { key: 'sickRemaining', width: 30 },
                { key: 'serviceIncentiveRemaining', width: 30 },
                { key: 'soloParentRemaining', width: 30 },
            ];
            headerRowEmployeeLeaves.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '92d050' },
                };
            });
        
            _employees.forEach(item => {
                if(item.employeeLeave){
                    worksheet10.addRow([
                        item.employeeId,
                        item.fullName,
                        item.employeeLeave.totalVacation ? item.employeeLeave.totalVacation : "",
                        item.employeeLeave.totalSick ? item.employeeLeave.totalSick : "",
                        item.employeeLeave.totalServiceIncentive ? item.employeeLeave.totalServiceIncentive : "",
                        item.employeeLeave.totalSoloParent ? item.employeeLeave.totalSoloParent : "",
                        item.employeeLeave.vacationRemaining ? item.employeeLeave.vacationRemaining : "",
                        item.employeeLeave.sickRemaining ? item.employeeLeave.sickRemaining : "",
                        item.employeeLeave.serviceIncentiveRemaining ? item.employeeLeave.serviceIncentiveRemaining : "",
                        item.employeeLeave.soloParentRemaining ? item.employeeLeave.soloParentRemaining : "",
                    ]);
                }
                else{
                    worksheet10.addRow([item.employeeId, item.fullName]);
                }
            });
        }
    
        //EmployeeStatuses
        const headerEmployeeStatuses = [
            'EmployeeId',
            'EmployeeName',
            'EmployeeStatus',
        ];
        const headerRowEmployeeStatuses = worksheet11.addRow(headerEmployeeStatuses);
        worksheet11.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'fullName', width: 30 },
            { key: 'status', width: 30 },
        ];
        headerRowEmployeeStatuses.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeStatuses){
                worksheet11.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeStatuses.status ? item.employeeStatuses.status : "",
                ]);
            }
            else{
                worksheet11.addRow([item.employeeId, item.fullName]);
            }
        });

        setLoadingRequest(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Masterlist.xlsx');
    }, [fetchDataEmployeeInfoForMasterlist, newLeave]);
    const generateDownloadForBulkUpdateTemplate = useCallback(async () => {
        const _employees = await fetchDataEmployeeInformationOnly();
        if(_employees && _employees.length <= 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please wait for the _employees to load");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('EmployeeInformation');
    
        const header = ['EmployeeId', 'EmployeeName', 'Location', 'Section', 'Position', 'Department', 'SalaryType', 'PayType', 'ShiftSchedule', 'Classification'];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeId', width: 25 },
            { key: 'employeeName', width: 30 },
            { key: 'location', width: 25 },
            { key: 'section', width: 25 },
            { key: 'position', width: 25 },
            { key: 'department', width: 25 },
            { key: 'salaryType', width: 25 },
            { key: 'payType', width: 25 },
            { key: 'shiftSchedule', width: 25 },
            { key: 'classification', width: 25 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        /* const employeeTemplate = [
            {
                employeeId: '<EMP1234>',
                employeeName: '<DELA CRUZ, JUAN>',
                location: '<MAIN OFFICE>',
                section: '<MAIN OFFICE>',
                position: '<MARKETING ASSISTANT>',
                department: '<WAREHOUSE>',
                salaryType: '<POSITION - DESIGNATION>',
                payType: '<WEEKLY>',
                shiftSchedule: '<MORNING SHIFT>',
                classification: '<MONTHLY>',
            },
        ]; */

        _employees.forEach(info => {
            worksheet.addRow({
                employeeId: info.employeeId ? info.employeeId : "",
                employeeName: info.fullName ? info.fullName : "",
                location: info.employeeInformation?.locationDescription ? info.employeeInformation?.locationDescription : "",
                section: info.employeeInformation?.sectionDescription ? info.employeeInformation?.sectionDescription : "",
                position: info.employeeInformation?.positionDescription ? info.employeeInformation?.positionDescription : "",
                department: info.employeeInformation?.departmentDescription ? info.employeeInformation?.departmentDescription : "",
                salaryType: info.employeeInformation?.salaryType ? info.employeeInformation?.salaryType : "",
                payType: info.employeeInformation?.payTypeDescription ? info.employeeInformation?.payTypeDescription : "",
                shiftSchedule: info.employeeInformation?.shiftScheduleShiftName ? info.employeeInformation?.shiftScheduleShiftName : "",
                classification: info.employeeInformation?.classificationDescription ? info.employeeInformation?.classificationDescription : "",
            });
        });
    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Information_Template.xlsx');
    }, [fetchDataEmployeeInformationOnly]);
    const generateDownloadLeaveTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('EmployeeLeave');
    
        const header = ['EmployeeId', 
            'EmployeeName', 
            'VacationLeave', 
            'SickLeave', 
            'ServiceIncentiveLeave', 
            'SoloParentLeave',
            'VacationLeaveRemaining',
            'SickLeaveRemaining',
            'ServiceIncentiveLeaveRemaining',
            'SoloParentLeaveRemaining',
            ];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeId', width: 25 },
            { key: 'employeeName', width: 30 },
            { key: 'totalVacation', width: 30 },
            { key: 'totalSick', width: 30 },
            { key: 'totalServiceIncentive', width: 30 },
            { key: 'totalSoloParent', width: 30 },
            { key: 'vacationRemaining', width: 30 },
            { key: 'sickRemaining', width: 30 },
            { key: 'serviceIncentiveRemaining', width: 30 },
            { key: 'soloParentRemaining', width: 30 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        const employeeTemplate = [
            {
                employeeId: '<EMP1234>',
                employeeName: '<DELA CRUZ, JUAN>',
                totalVacation: '<10.00>',
                totalSick: '<10.00>',
                totalServiceIncentive: '<10.00>',
                totalSoloParent: '<10.00>',
                vacationRemaining: '<10.00>',
                sickRemaining: '<10.00>',
                serviceIncentiveRemaining: '<10.00>',
                soloParentRemaining: '<10.00>',
            },
        ];

        employeeTemplate.forEach(info => {
            worksheet.addRow(info);
        });
    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Leave_Template.xlsx');
    }, []);
    const generateDownloadEmployeeInformation = useCallback(async () => {
        setLoadingRequest(true);

        const _employees = await fetchDataEmployeeInformationOnly();
        if(_employees && _employees.length <= 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please wait for the _employees to load");
            return;
        }
    
        const workbook = new ExcelJS.Workbook();
        const worksheet2 = workbook.addWorksheet('EmployeeInformation');
    
        //EmployeeInformation
        const headerEmployeeInformation = [
            'EmployeeId',
            'EmployeeName',
            'Location',
            'Employment',
            'Department',
            'Section',
            'Classification',
            'PayType',
            'ShiftSchedule',
            'Position',
            'SalaryType',
        ];
        const headerRowEmployeeInformation = worksheet2.addRow(headerEmployeeInformation);
        worksheet2.columns = [
            { key: 'employeeId', width: 20 },
            { key: 'employeeName', width: 30 },
            { key: 'location', width: 20 },
            { key: 'employment', width: 20 },
            { key: 'department', width: 20 },
            { key: 'section', width: 20 },
            { key: 'classification', width: 20 },
            { key: 'payType', width: 20 },
            { key: 'shiftSchedule', width: 20 },
            { key: 'position', width: 20 },
            { key: 'salaryType', width: 20 },
        ];
        headerRowEmployeeInformation.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        _employees.forEach(item => {
            if(item.employeeInformation){
                worksheet2.addRow([
                    item.employeeId,
                    item.fullName,
                    item.employeeInformation.locationDescription ? item.employeeInformation.locationDescription : "",
                    item.employeeInformation.employmentDescription ? item.employeeInformation.employmentDescription : "",
                    item.employeeInformation.departmentDescription ? item.employeeInformation.departmentDescription : "",
                    item.employeeInformation.sectionDescription ? item.employeeInformation.sectionDescription : "",
                    item.employeeInformation.classificationDescription ? item.employeeInformation.classificationDescription : "",
                    item.employeeInformation.payTypeDescription ? item.employeeInformation.payTypeDescription : "",
                    item.employeeInformation.shiftScheduleShiftName ? item.employeeInformation.shiftScheduleShiftName : "",
                    item.employeeInformation.positionDescription ? item.employeeInformation.positionDescription : "",
                    item.employeeInformation.salaryType ? item.employeeInformation.salaryType : "",
                ]);
            }
            else{
                worksheet2.addRow([item.employeeId]);
            }
        });
    
        setLoadingRequest(false);
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Information.xlsx');
    }, [fetchDataEmployeeInformationOnly]);

    const fetchDataForLocation = useCallback(async () => {
        const apiUrl =  domain + "/api/Location/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForEmployment = useCallback(async () => {
        const apiUrl =  domain + "/api/Employment/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForDepartment = useCallback(async () => {
        const apiUrl =  domain + "/api/Department/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForSection = useCallback(async () => {
        const apiUrl =  domain + "/api/Section/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForClassification = useCallback(async () => {
        const apiUrl =  domain + "/api/Classification/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForPaytype = useCallback(async () => {
        const apiUrl =  domain + "/api/Paytype/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForShiftSchedule = useCallback(async () => {
        const apiUrl =  domain + "/api/ShiftSchedule/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForPosition = useCallback(async () => {
        const apiUrl =  domain + "/api/Position/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchDataForCompany = useCallback(async () => {
        const apiUrl =  domain + "/api/Company/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const fetchSalaryType = [
        "Daily",
        "Monthly",
        "PositionDesignation",
        "PositionDesignationLaUnion"
    ]

    // const createAccountBulk = async (bulkData) => {
    //     const accessTemplate = await fetchDataAccessTemplate();
    //     const accounts = await fetchDataAccounts();
    //     const employeeInfo = await fetchDataEmployeeInfoForMasterlist();

    //     const foundTemplate = accessTemplate.find(data => 
    //         data.description.toLowerCase() === ("Employee").toLowerCase()
    //     );

    //     function generateUniqueUsernames(employee, existingUsernames) {
    //         const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
    //         const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
    //         let baseUsername = firstNameInitial + lastNameLower;
        
    //         let uniqueUsername = baseUsername;
    //         let counter = 1;
        
    //         while (existingUsernames.includes(uniqueUsername)) {
    //             uniqueUsername = `${baseUsername}${counter}`;
    //             counter += 1;
    //         }
        
    //         existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
    //         return uniqueUsername;
    //     }
        
    //     const apiUrl =  domain + "/api/Authentication";

    //     const existingUsernames = [];
    //     const dataToAdd = [];

    //     for(const employee of bulkData){
    //         const foundEmployee = employeeInfo.find(data => 
    //             data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
    //         );

    //         accounts.forEach(employee => {
    //             existingUsernames.push(employee.username);
    //         });
    
    //         const username = generateUniqueUsernames(employee, existingUsernames);
    //         existingUsernames.push(username);
    
    //         const data = {
    //             username: username,
    //             password: "password",
    //             employeePersonalInformationId: foundEmployee.id,
    //             accessTemplateId: foundTemplate.id
    //         };

    //         dataToAdd.push(data)
    //     }

    //     try {
    //         axios.post(apiUrl + `/register/bulk`, dataToAdd, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Content-Type': 'application/json'
    //             }
    //         });
            
    //     } catch (error) {
    //         setShowRequestMessage(true);
    //         setIsSuccess(false);
    //         console.error('Error:', error);
    //         const errorMessage = JSON.parse(error.response.request.responseText).message;
    //         setRequestMessage(errorMessage);
    //     }
    // }

    const uploadEmployeeData = async (file) => {
        setLoadingRequest(true);
        const dataLocation = await fetchDataForLocation();
        const dataEmployment = await fetchDataForEmployment();
        const dataDepartment = await fetchDataForDepartment();
        const dataSection = await fetchDataForSection();
        const dataClassification = await fetchDataForClassification();
        const dataPaytype = await fetchDataForPaytype();
        const dataShiftSchedule = await fetchDataForShiftSchedule();
        const dataPosition = await fetchDataForPosition();
        const dataCompany = await fetchDataForCompany();
        const dataLeaveTypes = await fetchDataLeaveTypes();
        const dataSalaryType = fetchSalaryType;
    
        function excelDateToJSDate(excelDate) {
            const date = new Date((excelDate - 25569) * 86400 * 1000);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    
        function convertToDateTimeLocal(dateStr) {
            if (!dateStr) return null;

            // Already ISO format
            if (
                typeof dateStr === "string" &&
                /^\d{4}-\d{2}-\d{2}T/.test(dateStr)
            ) {
                return dateStr;
            }

            let datetimeLocal;

            // dd/MM/yyyy
            if (
                typeof dateStr === "string" &&
                /^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)
            ) {
                datetimeLocal = dateStr;
            }
            // Excel serial
            else if (!isNaN(dateStr)) {
                datetimeLocal = excelDateToJSDate(Number(dateStr));
            } else {
                return null;
            }

            const [month, day, year] = datetimeLocal.split('/');

            return `${year}-${month}-${day}T00:00:00`;
        }
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
        function sanitizeValueIntType(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return value;
        }

        function sanitizeValueToNull(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return null;
            }
            return value;
        }
    
        /* function validateData(data) {
            const missingFields = [];
    
            data.forEach((item, index) => {
                const missing = [];
                if (!item.employeeId) missing.push('EmployeeId');
                if (!item.firstName) missing.push('FirstName');
                if (!item.lastName) missing.push('LastName');
                // if (!item.employeeInformation.company) missing.push('Company');
                // if (!item.employeeInformation.location) missing.push('Location');
                // if (!item.employeeInformation.employment) missing.push('Employment');
                // if (!item.employeeInformation.department) missing.push('Department');
                // if (!item.employeeInformation.section) missing.push('Section');
                // if (!item.employeeInformation.classification) missing.push('Classification');
                // if (!item.employeeInformation.payType) missing.push('PayType');
                // if (!item.employeeInformation.shiftSchedule) missing.push('ShiftSchedule');
                // if (!item.employeeInformation.position) missing.push('Position');
                if (missing.length > 0) {
                    missingFields.push(`Row ${index + 1}: Missing fields - ${missing.join(', ')}`);
                }
            });
    
            if (missingFields.length > 0) {
                return {
                    isValid: false,
                    message: `Invalid data in the file. Please check the mandatory fields.\n${missingFields.join('\n')}`
                };
            }
    
            return { isValid: true };
        } */
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeePersonalInformation = parseWorksheet(workbook.Sheets['EmployeePersonalInformation']);
            const employeeInformation = parseWorksheet(workbook.Sheets['EmployeeInformation']);
            const employeeAccountInformation = parseWorksheet(workbook.Sheets['AccountInformation']);
            const employeeSalary = parseWorksheet(workbook.Sheets['EmployeeSalary']);
            const employeeBankAccount = parseWorksheet(workbook.Sheets['BankAccount']);
            const employeeEducationAttainments = parseWorksheet(workbook.Sheets['EducationalAttainment']);
            const employeeDependents = parseWorksheet(workbook.Sheets['Dependents']);
            const employeeFamilyData = parseWorksheet(workbook.Sheets['FamilyData']);
            const employeeEmergencyContacts = parseWorksheet(workbook.Sheets['EmergencyContact']);
            const employeeLeaves = parseWorksheet(workbook.Sheets['EmployeeLeaves2']);
            const employeeStatus = parseWorksheet(workbook.Sheets['EmployeeStatus']);
            const employeeLeaveInformations = parseWorksheet(workbook.Sheets['EmployeeLeaves']);
    
            const bulkData = [];
            const processedIds = new Set();
    
            employeePersonalInformation.forEach(personalInfo => {
                if(!personalInfo.EmployeeId) {
                    return;
                }
                if (processedIds.has(personalInfo.EmployeeId)) {
                    return; // Skip duplicate EmployeeId
                }
                processedIds.add(personalInfo.EmployeeId);
    
                const filteredEmployeeInformation = employeeInformation.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredAccountInformation = employeeAccountInformation.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredSalary = employeeSalary.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredBankAccount = employeeBankAccount.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEducationAttainments = employeeEducationAttainments.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredDependents = employeeDependents.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredFamilyData = employeeFamilyData.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmergencyContacts = employeeEmergencyContacts.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeLeaves = employeeLeaves.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeStatus = employeeStatus.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeLeaveInformation = employeeLeaveInformations.filter(row => row.EmployeeId === personalInfo.EmployeeId);
    
                let foundLocation = null;
                let foundEmployment = null;
                let foundDepartment = null;
                let foundSection = null;
                let foundClassification = null;
                let foundPaytype = null;
                let foundShiftSchedule = null;
                let foundPosition = null;
                let foundCompany = null;
                let foundSalaryType = null;

                if (filteredEmployeeInformation.length > 0) {
                    const employeeInfo = filteredEmployeeInformation[0];

                    foundLocation = dataLocation.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Location).toString().toLowerCase()
                    );
                    foundEmployment = dataEmployment.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Employment).toString().toLowerCase()
                    );
                    foundDepartment = dataDepartment.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Department).toString().toLowerCase()
                    );
                    foundSection = dataSection.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Section).toString().toLowerCase()
                    );
                    foundClassification = dataClassification.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Classification).toString().toLowerCase()
                    );
                    foundPaytype = dataPaytype.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.PayType).toString().toLowerCase()
                    );
                    foundShiftSchedule = dataShiftSchedule.find(data => 
                        data.shiftName.toLowerCase() === sanitizeValue(employeeInfo.ShiftSchedule).toString().toLowerCase()
                    );
                    foundPosition = dataPosition.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Position).toString().toLowerCase()
                    );
                    foundCompany = dataCompany.find(data => 
                        data.name.toLowerCase() === sanitizeValue(employeeInfo.Company).toString().toLowerCase()
                    );
                    foundSalaryType = dataSalaryType.find(data => {
                            let value = sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase();
                            if(sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation" 
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation"){
                                value = "PositionDesignation";
                            }
                            return  data.toLowerCase() === value.toLowerCase()
                        }
                    );
                }

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeeId: sanitizeValue(personalInfo?.EmployeeId ?? "").toString().trim(),
                    lastName: sanitizeValue(personalInfo?.LastName ?? ""),
                    firstName: sanitizeValue(personalInfo?.FirstName ?? ""),
                    middleName: sanitizeValue(personalInfo?.MiddleName ?? ""),
                    extensionName: sanitizeValue(personalInfo?.ExtensionName ?? ""),
                    fullName: sanitizeValue(personalInfo?.LastName ?? "") + ", " + sanitizeValue(personalInfo.FirstName ?? ""),
                    nickName: sanitizeValue(personalInfo?.NickName ?? ""),
                    age: personalInfo?.Age ? sanitizeValueToNull(personalInfo?.Age.toString()) : 0,
                    dateOfBirth: personalInfo?.DateOfBirth ? convertToDateTimeLocal(sanitizeValueToNull(personalInfo?.DateOfBirth)) : null,
                    placeOfBirth: sanitizeValue(personalInfo?.PlaceOfBirth ?? ""),
                    civilStatus: sanitizeValue(personalInfo?.CivilStatus ?? ""),
                    bloodType: sanitizeValue(personalInfo?.BloodType ?? ""),
                    height: sanitizeValue(personalInfo?.Height ?? ""),
                    weight: sanitizeValue(personalInfo?.Weight ?? ""),
                    citizenship: sanitizeValue(personalInfo?.Citizenship ?? ""),
                    religion: sanitizeValue(personalInfo?.Religion ?? ""),
                    gender: sanitizeValue(personalInfo?.Gender ?? ""),
                    mobileNumber: sanitizeValue(personalInfo?.MobileNumber.toString()),
                    emailAddress: sanitizeValue(personalInfo?.EmailAddress ?? ""),
                    blkLot: sanitizeValue(personalInfo?.BlkLot.toString()),
                    street: sanitizeValue(personalInfo?.Street ?? ""),
                    barangay: sanitizeValue(personalInfo?.Barangay ?? ""),
                    city: sanitizeValue(personalInfo?.City ?? ""),
                    postalCode: sanitizeValue(personalInfo?.PostalCode.toString()),
                    yearsOfStay: personalInfo?.YearsOfStay ? sanitizeValueToNull(personalInfo.YearsOfStay.toString()) : 0,
                    deviceNumber: sanitizeValue(personalInfo?.DeviceNumber?.toString()),
                    employeeInformation: filteredEmployeeInformation[0] ? {
                        employeeId: sanitizeValue(filteredEmployeeInformation[0].EmployeeId).toString(),
                        location: filteredEmployeeInformation[0].Location ? 
                                foundLocation ?
                                    sanitizeValue(filteredEmployeeInformation[0].Location).toString() 
                                    :
                                    ""
                                : 
                                "",
                        dateEmployed: filteredEmployeeInformation[0].DateEmployed ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateEmployed)) : null,
                        dateRegular: filteredEmployeeInformation[0].DateRegular ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateRegular)) : null,
                        dateProbationary: filteredEmployeeInformation[0].DateProbationary ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateProbationary)) : null,
                        dateResigned: filteredEmployeeInformation[0].DateResigned ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateResigned)) : null,
                        dateProjectBase: filteredEmployeeInformation[0].DateProjectBase ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateProjectBase)) : null,
                        dateContractual: filteredEmployeeInformation[0].DateContractual ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateContractual)) : null,
                        employmentDuration: filteredEmployeeInformation[0].EmploymentDuration ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].EmploymentDuration)) : null,
                        employment: filteredEmployeeInformation[0].Employment ? 
                                    foundEmployment ?
                                        sanitizeValue(filteredEmployeeInformation[0].Employment).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        department: filteredEmployeeInformation[0].Department ? 
                                    foundDepartment ?
                                        sanitizeValue(filteredEmployeeInformation[0].Department).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        section: filteredEmployeeInformation[0].Section ? 
                                foundSection ?
                                    sanitizeValue(filteredEmployeeInformation[0].Section).toString() 
                                    :
                                    ""
                                : 
                                "",
                        classification: filteredEmployeeInformation[0].Classification ? 
                                    foundClassification ?
                                        sanitizeValue(filteredEmployeeInformation[0].Classification).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        payType: filteredEmployeeInformation[0].PayType ? 
                                foundPaytype ?
                                    sanitizeValue(filteredEmployeeInformation[0].PayType).toString() 
                                    :
                                    ""
                                : 
                                "",
                        shiftSchedule: filteredEmployeeInformation[0].ShiftSchedule ? 
                                    foundShiftSchedule ?
                                        sanitizeValueIntType(filteredEmployeeInformation[0].ShiftSchedule).toString() 
                                        :
                                        null
                                    : 
                                    null,
                        position: filteredEmployeeInformation[0].Position ? 
                                foundPosition ?
                                    sanitizeValue(filteredEmployeeInformation[0].Position).toString() 
                                    :
                                    ""
                                : 
                                "",
                        company: filteredEmployeeInformation[0].Company ? 
                            foundCompany ?
                                sanitizeValue(filteredEmployeeInformation[0].Company).toString() 
                                :
                                ""
                            : 
                            "",
                        salaryType: filteredEmployeeInformation[0].SalaryType ? 
                            foundSalaryType ?
                                sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() === "Position - Designation" || sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() === "Position-Designation" ?
                                "PositionDesignation"
                                :
                                sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() 
                                    :
                                    ""
                            : 
                            "",
                        createdDate: new Date(),
                        createdBy: 0,
                    } : null,
                    employeeAccountInformation: filteredAccountInformation[0] ? {
                        employeeId: sanitizeValue(filteredAccountInformation[0].EmployeeId).toString(),
                        sss: sanitizeValue(filteredAccountInformation[0].Sss).toString(),
                        tin: sanitizeValue(filteredAccountInformation[0].Tin).toString(),
                        passport: sanitizeValue(filteredAccountInformation[0].Passport).toString(),
                        philhealth: sanitizeValue(filteredAccountInformation[0].Philhealth).toString(),
                        pagibig: sanitizeValue(filteredAccountInformation[0].Pagibig).toString(),
                    } : null,
                    employeeBankAccount: filteredBankAccount ? filteredBankAccount.map(bank => ({
                        employeeId: sanitizeValue(bank.EmployeeId).toString(),
                        bankAccount: sanitizeValue(bank.BankAccount).toString(),
                        bankName: sanitizeValue(bank.BankName),
                    })) : [],
                    employeeSalary: filteredSalary[0] ? {
                        employeeId: sanitizeValue(filteredSalary[0].EmployeeId).toString(),
                        salary: sanitizeValueIntType(filteredSalary[0].Salary).toString(),
                        allowance: sanitizeValueIntType(filteredSalary[0].Allowance).toString()
                    } : null,
                    employeeEducationAttainments: filteredBankAccount ? filteredEducationAttainments.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        level: sanitizeValue(data.Level),
                        schoolName: sanitizeValue(data.SchoolName),
                        address: sanitizeValue(data.Address),
                        dateFrom: data.DateFrom ? convertToDateTimeLocal(sanitizeValueToNull(data.DateFrom)) : null,
                        dateTo: data.DateTo ? convertToDateTimeLocal(sanitizeValueToNull(data.DateTo)) : null,
                        course: sanitizeValue(data.Course),
                        honors: sanitizeValue(data.Honors),
                    })) : [],
                    employeeDependents: filteredDependents ? filteredDependents.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        lastName: sanitizeValue(data.LastName),
                        firstName: sanitizeValue(data.FirstName),
                        middleName: sanitizeValue(data.MiddleName),
                        extensionName: sanitizeValue(data.ExtensionName),
                        dateOfBirth: data.DateOfBirth ? convertToDateTimeLocal(sanitizeValueToNull(data.DateOfBirth)) : null,
                        gender: sanitizeValue(data.Gender),
                        civilStatus: sanitizeValue(data.CivilStatus),
                    })) : [],
                    employeeFamilyData: filteredFamilyData ? filteredFamilyData.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        name: sanitizeValue(data.Name),
                        dateOfBirth: data.DateOfBirth ? convertToDateTimeLocal(sanitizeValueToNull(data.DateOfBirth)) : null,
                        occupation: sanitizeValue(data.Occupation),
                        contactNumber: sanitizeValue(data.ContactNumber).toString(),
                        age: sanitizeValueIntType(data.Age),
                        address: sanitizeValue(data.Address),
                        relationship: sanitizeValue(data.Relationship),
                    })) : [],
                    employeeEmergencyContacts: filteredEmergencyContacts ? filteredEmergencyContacts.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        name: sanitizeValue(data.Name),
                        relationship: sanitizeValue(data.relationship),
                        contactNumber: sanitizeValue(data.ContactNumber).toString(),
                        address: sanitizeValue(data.Address),
                    })) : [],
                    employeeLeave: filteredEmployeeLeaves[0] ? {
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        totalVacation: sanitizeValueIntType(data.VacationLeave),
                        totalSick: sanitizeValueIntType(data.SickLeave),
                        totalServiceIncentive: sanitizeValueIntType(data.ServiceIncentiveLeave),
                        totalSoloParent: sanitizeValueIntType(data.SoloParentLeave),
                        vacationRemaining: sanitizeValueIntType(data.VacationLeaveRemaining),
                        sickRemaining: sanitizeValueIntType(data.SickLeaveRemaining),
                        serviceIncentiveRemaining: sanitizeValueIntType(data.ServiceIncentiveLeaveRemaining),
                        soloParentRemaining: sanitizeValueIntType(data.SoloParentLeaveRemaining),
                    } : null,
                    employeeStatuses: filteredEmployeeStatus[0] ? {
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        status: data.EmployeeStatus ? sanitizeValue(data.EmployeeStatus) : "Active",
                    } : null,
                    employeeLeaveInformation: filteredEmployeeLeaveInformation 
                        ? filteredEmployeeLeaveInformation.map(data => ({
                                employeeId: sanitizeValue(data.EmployeeId).toString(),
                                leaveTypeId: dataLeaveTypes.find(i => i.description === data.LeaveType)?.id ?? 0,
                                initialValue: sanitizeValueIntType(data.InitialValue),
                                remainingValue: sanitizeValueIntType(data.RemainingValue),
                                q1Value: sanitizeValueIntType(data["Q1Value(Jan-Mar)"]),
                                q2Value: sanitizeValueIntType(data["Q2Value(Apr-Jun)"]),
                                q3Value: sanitizeValueIntType(data["Q3Value(Jul-Sep)"]),
                                q4Value: sanitizeValueIntType(data["Q4Value(Oct-Dec)"]),
                            })) 
                        : [],
                });
            });
    
            // Validate the bulk data
            /* const validation = validateData(bulkData);
            if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }
    
            let existingDataById = [];
            let ids = "";
    
            bulkData.forEach(data => {
                const existingEmployee = employees.find(employee => employee.employeeId === data.employeeId);
                if (existingEmployee) {
                    existingDataById.push(existingEmployee);
    
                    if (ids === "") {
                        ids = `${data.employeeId}`;
                    } else {
                        ids = `${ids}, ${data.employeeId}`;
                    }
                }
            });
    
            if (existingDataById.length > 0) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(`Employee Id/s : ${ids} already exist`);
                return;
            } */
    
            const apiUrl = `${domain}/api/Employee/upload-bulk`;

            console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            try {
                const response = await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                console.log('Upload successful:', response.data);

                //await createAccountBulk(bulkData);

                await SetAuditTrail({
                    setupArea: "Employee List", 
                    actionTaken: "insert", 
                    field: "Upload Employee/s", 
                    newValue: "-", 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });
                await fetchDataBasicInfo();
                
                setRequestMessage('Upload successful');
                setShowRequestMessage(true);
                setIsSuccess(true);
            } catch (error) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                console.error('Error:', error);
                const errorResponse = JSON.parse(error.response.request.responseText);
                if (errorResponse.errors) {
                    // Get the first validation error message
                    const firstErrorKey = Object.keys(errorResponse.errors)[0]; // e.g., "[0].EmployeeInformation"
                    const errorMessage = errorResponse.errors[firstErrorKey][0]; // "The EmployeeInformation field is required."
        
                    setRequestMessage(errorMessage);
                } else {
                    setRequestMessage("An unknown error occurred.");
                }
            } finally {
                setLoadingRequest(false);
            }
        };
    
        reader.readAsArrayBuffer(file);
    };
    const uploadForUpdateBulkEmployeeData = async (file) => {
        setLoadingRequest(true);
        const employeesInfo = await fetchDataEmployeeInfoForMasterlist();
        const dataLocation = await fetchDataForLocation();
        const dataEmployment = await fetchDataForEmployment();
        const dataDepartment = await fetchDataForDepartment();
        const dataSection = await fetchDataForSection();
        const dataClassification = await fetchDataForClassification();
        const dataPosition = await fetchDataForPosition();
        const dataSalaryType = fetchSalaryType;
        const dataPaytype = await fetchDataForPaytype();
        const dataShiftSchedule = await fetchDataForShiftSchedule();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }

        const downloadErrorFile = (missingEmployeeIds) => {
            // Create a worksheet
            const ws = XLSX.utils.json_to_sheet(missingEmployeeIds.map(id => ({ 'Non-Existing Employee Ids': id })));
            
            // Create a workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Missing Employee IDs');
            
            // Generate Excel file and trigger download
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            const buf = new ArrayBuffer(wbout.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < wbout.length; ++i) {
                view[i] = wbout.charCodeAt(i) & 0xFF;
            }
            
            const blob = new Blob([buf], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Error_File.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeeInformation = parseWorksheet(workbook.Sheets['EmployeeInformation']);
            let validData = [];
            let missingIds = [];

            employeeInformation.forEach(personalInfo => {
                const mainInfo = employeesInfo.find(employee => {
                    // console.log(personalInfo)
                    return employee.employeeId === personalInfo.EmployeeId.toString()
                });
    
                if (!mainInfo && !missingIds.includes(personalInfo.EmployeeId)) {
                    missingIds.push(personalInfo.EmployeeId);
                } else if (mainInfo && !validData.includes(personalInfo.EmployeeId)) {
                    validData.push(personalInfo);
                }
            });

            const bulkData = [];

            function validateData(data) {
                const missingFields = [];
        
                data.forEach((item, index) => {
                    const missing = [];
                    if (!item.employeeId) missing.push('EmployeeId');
                    // if (!item.locationId) missing.push('Location');
                    // if (!item.sectionId) missing.push('Section');
                    // if (!item.positionId) missing.push('Position');
                    // if (!item.departmentId) missing.push('Department');
                    // if (!item.salaryType) missing.push('SalaryType');
                    // if (!item.payTypeId) missing.push('PayType');
                    // if (!item.shiftScheduleId) missing.push('ShiftSchedule');
                    // if (!item.classificationId) missing.push('Classification');
                    if (missing.length > 0) {
                        missingFields.push(`Row ${index + 1}: Missing fields - ${missing.join(', ')}`);
                    }
                });
        
                if (missingFields.length > 0) {
                    return {
                        isValid: false,
                        message: `Invalid data in the file. Please check the mandatory fields.\n${missingFields.join('\n')}`
                    };
                }
        
                return { isValid: true };
            }

            validData.forEach(personalInfo => {
                const filteredEmployeeInformation = employeeInformation.find(row => row.EmployeeId === personalInfo.EmployeeId);
                const majorEmployeeInfo = employeesInfo.find(data => data.employeeId === personalInfo.EmployeeId.toString());

                let foundLocation = null;
                let foundEmployment = null;
                let foundDepartment = null;
                let foundSection = null;
                let foundClassification = null;
                let foundPosition = null;
                let foundSalaryType = null;
                let foundPaytype = null;
                let foundShiftSchedule = null;

                if (filteredEmployeeInformation) {
                    const employeeInfo = filteredEmployeeInformation;

                    foundLocation = dataLocation.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Location).toString().toLowerCase()
                    );
                    foundEmployment = dataEmployment.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Employment).toString().toLowerCase()
                    );
                    foundDepartment = dataDepartment.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Department).toString().toLowerCase()
                    );
                    foundSection = dataSection.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Section).toString().toLowerCase()
                    );
                    foundClassification = dataClassification.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Classification).toString().toLowerCase()
                    );
                    foundPosition = dataPosition.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Position).toString().toLowerCase()
                    );
                    foundPaytype = dataPaytype.find(data => {
                        return data.description.toLowerCase() === sanitizeValue(employeeInfo.PayType).toString().toLowerCase()
                    }
                    );
                    foundShiftSchedule = dataShiftSchedule.find(data => 
                        data.shiftName.toLowerCase() === sanitizeValue(employeeInfo.ShiftSchedule).toString().toLowerCase()
                    );
                    foundSalaryType = dataSalaryType.find(data => {
                            let value = sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase();
                            if(sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation" 
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation"){
                                value = "PositionDesignation";
                            }

                            if(sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation (la union)" 
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation(la union)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation (launion)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation(launion)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation (la union)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation(la union)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation (launion)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation(launion)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "positiondesignation (la union)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "positiondesignation(la union)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "positiondesignation (launion)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "positiondesignation(launion)"
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "positiondesignationlaunion"
                            ){
                                value = "PositionDesignationLaUnion";
                            }
                            return data.toLowerCase() === value.toLowerCase()
                        }
                    );
                }
                
                bulkData.push({
                    employeeId: majorEmployeeInfo.employeeId,
                    locationId: foundLocation ? foundLocation.id : null,
                    employmentId: foundEmployment ? foundEmployment.id : null,
                    departmentId: foundDepartment ? foundDepartment.id : null,
                    sectionId: foundSection ? foundSection.id : null,
                    classificationId: foundClassification ? foundClassification.id : null,
                    payTypeId: foundPaytype ? foundPaytype.id : null,
                    shiftScheduleId: foundShiftSchedule ? foundShiftSchedule.id : null,
                    positionId: foundPosition ? foundPosition.id : null,
                    salaryType: foundSalaryType ? (foundSalaryType === "Position-Designation" 
                                                    || foundSalaryType === "PositionDesignation"
                                                    || foundSalaryType === "Position - Designation") ? "PositionDesignation" : 
                                                        (foundSalaryType === "Position-Designation (La Union)" 
                                                            || foundSalaryType === "Position-Designation (LaUnion)" 
                                                            || foundSalaryType === "PositionDesignationLaUnion"
                                                            || foundSalaryType === "Position-Designation(La Union)" 
                                                            || foundSalaryType === "Position - Designation (La Union)"
                                                            || foundSalaryType === "Position - Designation(La Union)"
                                                            || foundSalaryType === "Position - Designation(LaUnion)"
                                                        ) ? "PositionDesignationLaUnion" :
                                                    foundSalaryType : null,
                });
            });

            const validation = validateData(bulkData);
            if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }

            if(validData.length > 0){
                setShowRequestMessage(true);
                setIsSuccess(true);

                if(missingIds.length > 0){
                    if(missingIds.length <= 10){
                        setShowRequestWarningMessage(true);
                        setRequestWarningMessage(`Employee ID/s: ${missingIds.join(', ')} cannot be found!`);
                    } else {
                        setShowRequestWarningMessage(true);
                        setRequestWarningMessage(`Please check the Error_File.xlsx for non existing employee ids`);
                        downloadErrorFile(missingIds);
                    }
                }

                const apiUrl = `${domain}/api/Employee/update-information/bulk`;

                // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
                try {
                    const response = await axios.put(apiUrl, bulkData, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    
                    console.log('Upload successful:', response.data);

                    await SetAuditTrail({
                        setupArea: "Employee List", 
                        actionTaken: "update", 
                        field: "Upload For Bulk Update", 
                        newValue: "-", 
                        oldValue: "-", 
                        dateSaved: new Date(), 
                        savedById: user.id
                    });
                    await fetchDataBasicInfo();
                    
                    setRequestMessage('Update successful');
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                } catch (error) {
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = JSON.parse(error.response.request.responseText).message;
                    setRequestMessage(errorMessage);
                } finally {
                    setLoadingRequest(false);
                }
            } else {
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage("All the info cannot be added. Please check the data");
            }

            setLoadingRequest(false);
        };
    
        reader.readAsArrayBuffer(file);
    };
    const uploadForUpdateLeaveEmployeeData = async (file) => {
        setLoadingRequest(true);
        const employeesInfo = await fetchDataEmployeeInfoForMasterlist();

        const downloadErrorFile = (missingEmployeeIds) => {
            // Create a worksheet
            const ws = XLSX.utils.json_to_sheet(missingEmployeeIds.map(id => ({ 'Non-Existing Employee Ids': id })));
            
            // Create a workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Missing Employee IDs');
            
            // Generate Excel file and trigger download
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            const buf = new ArrayBuffer(wbout.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < wbout.length; ++i) {
                view[i] = wbout.charCodeAt(i) & 0xFF;
            }
            
            const blob = new Blob([buf], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Error_File.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeeInformation = parseWorksheet(workbook.Sheets['EmployeeLeave']);
            let validData = [];
            let missingIds = [];

            employeeInformation.forEach(personalInfo => {
                const mainInfo = employeesInfo.find(employee => {
                    return employee.employeeId === personalInfo.EmployeeId.toString()
                });
    
                if (!mainInfo && !missingIds.includes(personalInfo.EmployeeId)) {
                    missingIds.push(personalInfo.EmployeeId);
                } else if (mainInfo && !validData.includes(personalInfo.EmployeeId)) {
                    validData.push(personalInfo);
                }
            });

            const bulkData = [];

            validData.forEach(personalInfo => {
                const data = {
                    employeeId: personalInfo?.EmployeeId?.toString(),
                    totalVacation: personalInfo.VacationLeave ? personalInfo.VacationLeave : 0,
                    totalSick: personalInfo.SickLeave ? personalInfo.SickLeave : 0,
                    totalServiceIncentive: personalInfo.ServiceIncentiveLeave ? personalInfo.ServiceIncentiveLeave : 0,
                    totalSoloParent: personalInfo.SoloParentLeave ? personalInfo.SoloParentLeave : 0,
                    vacationRemaining: personalInfo.VacationLeaveRemaining ? personalInfo.VacationLeaveRemaining : 0,
                    sickRemaining: personalInfo.SickLeaveRemaining ? personalInfo.SickLeaveRemaining : 0,
                    serviceIncentiveRemaining: personalInfo.ServiceIncentiveLeaveRemaining ? personalInfo.ServiceIncentiveLeaveRemaining : 0,
                    soloParentRemaining: personalInfo.SoloParentLeaveRemaining ? personalInfo.SoloParentLeaveRemaining : 0,
                }

                bulkData.push(data)
            });

            console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));

            if(validData.length > 0){

                if(missingIds.length > 0){
                    if(missingIds.length <= 10){
                        setShowRequestWarningMessage(true);
                        setRequestWarningMessage(`Employee ID/s: ${missingIds.join(', ')} cannot be found!`);
                    } else {
                        setShowRequestWarningMessage(true);
                        setRequestWarningMessage(`Please check the Error_File.xlsx for non existing employee ids`);
                        downloadErrorFile(missingIds);
                    }
                }

                const apiUrlUpdate =  domain + "/api/Employee/update-leave/bulk";
            
                try {
                    await axios.put(apiUrlUpdate, bulkData, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });

                    await SetAuditTrail({
                        setupArea: "Employee List", 
                        actionTaken: "update", 
                        field: "Upload For Leave Update", 
                        newValue: "-", 
                        oldValue: "-", 
                        dateSaved: new Date(), 
                        savedById: user.id
                    });
                    
                    console.log('Data updated successfully');
                    
                    setShowRequestMessage(true);
                    setIsSuccess(true);
                } catch (error) {
                    console.error('There was a problem updating data:', error);
                    
                    setLoadingRequest(false);
                    setShowRequestMessage(true);
                    setIsSuccess(false);
                    console.error('Error:', error);
                    const errorMessage = JSON.parse(error.response.request.responseText).message;
                    setRequestMessage(errorMessage);
                }
            } else {
                if(missingIds.length > 0){
                    if(missingIds.length <= 10){
                        setShowRequestWarningMessage(true);
                        setRequestWarningMessage(`Employee ID/s: ${missingIds.join(', ')} cannot be found!`);
                    } else {
                        setShowRequestWarningMessage(true);
                        setRequestWarningMessage(`Please check the Error_File.xlsx for non existing employee ids`);
                        downloadErrorFile(missingIds);
                    }
                }

                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage("All the info cannot be added. Please check the data");
            }

            await fetchDataBasicInfo();
            setLoadingRequest(false);
        };
    
        reader.readAsArrayBuffer(file);
    };

    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }

    function handleFileUploadForBulkUpdate(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadForUpdateBulkEmployeeData(file);
    }
    function handleFileUploadLeave(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadForUpdateLeaveEmployeeData(file);
    }

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);


    const [showUpdateMasterlistForm, setShowUpdateMasterlistForm] = useState(false)

    const openUpdateMasterlistFormHandleClick = () => {
        setShowUpdateMasterlistForm(true)
    }

    const closeUpdateMasterlistFormHandleClick = () => {
        setShowUpdateMasterlistForm(false)
    }
    
    const updateMasterlistData = async (file) => {
        setLoadingRequest(true);
        const dataLocation = await fetchDataForLocation();
        const dataEmployment = await fetchDataForEmployment();
        const dataDepartment = await fetchDataForDepartment();
        const dataSection = await fetchDataForSection();
        const dataClassification = await fetchDataForClassification();
        const dataPaytype = await fetchDataForPaytype();
        const dataShiftSchedule = await fetchDataForShiftSchedule();
        const dataPosition = await fetchDataForPosition();
        const dataCompany = await fetchDataForCompany();
        const dataLeaveTypes = await fetchDataLeaveTypes();
        const dataSalaryType = fetchSalaryType;
    
        function excelDateToJSDate(excelDate) {
            const date = new Date((excelDate - 25569) * 86400 * 1000);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    
        function convertToDateTimeLocal(dateStr) {
            if(dateStr){
                const datetimeLocal = excelDateToJSDate(dateStr);
                const [day, month, year] = datetimeLocal.split('/');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`;
            }

            return null;
        }
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
        function sanitizeValueIntType(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return 0;
            }
            return value;
        }

        function sanitizeValueToNull(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return null;
            }
            return value;
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const employeePersonalInformation = parseWorksheet(workbook.Sheets['EmployeePersonalInformation']);
            const employeeInformation = parseWorksheet(workbook.Sheets['EmployeeInformation']);
            const employeeAccountInformation = parseWorksheet(workbook.Sheets['AccountInformation']);
            const employeeSalary = parseWorksheet(workbook.Sheets['EmployeeSalary']);
            const employeeBankAccount = parseWorksheet(workbook.Sheets['BankAccount']);
            const employeeEducationAttainments = parseWorksheet(workbook.Sheets['EducationalAttainment']);
            const employeeDependents = parseWorksheet(workbook.Sheets['Dependents']);
            const employeeFamilyData = parseWorksheet(workbook.Sheets['FamilyData']);
            const employeeEmergencyContacts = parseWorksheet(workbook.Sheets['EmergencyContact']);
            const employeeLeaves = parseWorksheet(workbook.Sheets['EmployeeLeaves2']);
            const employeeStatus = parseWorksheet(workbook.Sheets['EmployeeStatus']);
            const employeeLeaveInformations = parseWorksheet(workbook.Sheets['EmployeeLeaves']);
    
            const bulkData = [];
            const processedIds = new Set();
    
            employeePersonalInformation.forEach(personalInfo => {
                if(!personalInfo.EmployeeId) {
                    return;
                }
                if (processedIds.has(personalInfo.EmployeeId)) {
                    return; // Skip duplicate EmployeeId
                }
                processedIds.add(personalInfo.EmployeeId);
    
                const filteredEmployeeInformation = employeeInformation.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredAccountInformation = employeeAccountInformation.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredSalary = employeeSalary.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredBankAccount = employeeBankAccount.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEducationAttainments = employeeEducationAttainments.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredDependents = employeeDependents.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredFamilyData = employeeFamilyData.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmergencyContacts = employeeEmergencyContacts.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeLeaves = employeeLeaves.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeStatus = employeeStatus.filter(row => row.EmployeeId === personalInfo.EmployeeId);
                const filteredEmployeeLeaveInformation = employeeLeaveInformations.filter(row => row.EmployeeId === personalInfo.EmployeeId);
    
                let foundLocation = null;
                let foundEmployment = null;
                let foundDepartment = null;
                let foundSection = null;
                let foundClassification = null;
                let foundPaytype = null;
                let foundShiftSchedule = null;
                let foundPosition = null;
                let foundCompany = null;
                let foundSalaryType = null;

                if (filteredEmployeeInformation.length > 0) {
                    const employeeInfo = filteredEmployeeInformation[0];

                    foundLocation = dataLocation.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Location).toString().toLowerCase()
                    );
                    foundEmployment = dataEmployment.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Employment).toString().toLowerCase()
                    );
                    foundDepartment = dataDepartment.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Department).toString().toLowerCase()
                    );
                    foundSection = dataSection.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Section).toString().toLowerCase()
                    );
                    foundClassification = dataClassification.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Classification).toString().toLowerCase()
                    );
                    foundPaytype = dataPaytype.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.PayType).toString().toLowerCase()
                    );
                    foundShiftSchedule = dataShiftSchedule.find(data => 
                        data.shiftName.toLowerCase() === sanitizeValue(employeeInfo.ShiftSchedule).toString().toLowerCase()
                    );
                    foundPosition = dataPosition.find(data => 
                        data.description.toLowerCase() === sanitizeValue(employeeInfo.Position).toString().toLowerCase()
                    );
                    foundCompany = dataCompany.find(data => 
                        data.name.toLowerCase() === sanitizeValue(employeeInfo.Company).toString().toLowerCase()
                    );
                    foundSalaryType = dataSalaryType.find(data => {
                            let value = sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase();
                            if(sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position - designation" 
                            || sanitizeValue(employeeInfo.SalaryType).toString().toLowerCase() === "position-designation"){
                                value = "PositionDesignation";
                            }
                            return  data.toLowerCase() === value.toLowerCase()
                        }
                    );
                }

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeeId: sanitizeValue(personalInfo?.EmployeeId ?? "").toString().trim(),
                    lastName: sanitizeValue(personalInfo?.LastName ?? ""),
                    firstName: sanitizeValue(personalInfo?.FirstName ?? ""),
                    middleName: sanitizeValue(personalInfo?.MiddleName ?? ""),
                    extensionName: sanitizeValue(personalInfo?.ExtensionName ?? ""),
                    fullName: sanitizeValue(personalInfo?.LastName ?? "") + ", " + sanitizeValue(personalInfo?.FirstName ?? ""),
                    nickName: sanitizeValue(personalInfo?.NickName ?? ""),
                    age: personalInfo.Age ? sanitizeValueToNull(personalInfo?.Age?.toString()) : null,
                    dateOfBirth: personalInfo?.DateOfBirth ? convertToDateTimeLocal(sanitizeValueToNull(personalInfo?.DateOfBirth)) : null,
                    placeOfBirth: sanitizeValue(personalInfo?.PlaceOfBirth ?? ""),
                    civilStatus: sanitizeValue(personalInfo?.CivilStatus ?? ""),
                    bloodType: sanitizeValue(personalInfo?.BloodType ?? ""),
                    height: sanitizeValue(personalInfo?.Height ?? ""),
                    weight: sanitizeValue(personalInfo?.Weight ?? ""),
                    citizenship: sanitizeValue(personalInfo?.Citizenship ?? ""),
                    religion: sanitizeValue(personalInfo?.Religion ?? ""),
                    gender: sanitizeValue(personalInfo?.Gender ?? ""),
                    mobileNumber: sanitizeValue(personalInfo?.MobileNumber?.toString()),
                    emailAddress: sanitizeValue(personalInfo?.EmailAddress ?? ""),
                    blkLot: sanitizeValue(personalInfo?.BlkLot?.toString()),
                    street: sanitizeValue(personalInfo?.Street ?? ""),
                    barangay: sanitizeValue(personalInfo?.Barangay ?? ""),
                    city: sanitizeValue(personalInfo?.City),
                    postalCode: sanitizeValue(personalInfo?.PostalCode.toString()),
                    yearsOfStay: personalInfo?.YearsOfStay ? sanitizeValueToNull(personalInfo?.YearsOfStay?.toString()) : null,
                    deviceNumber: sanitizeValue(personalInfo?.DeviceNumber?.toString()),
                    employeeInformation: filteredEmployeeInformation[0] ? {
                        employeeId: sanitizeValue(filteredEmployeeInformation[0].EmployeeId).toString(),
                        location: filteredEmployeeInformation[0].Location ? 
                                foundLocation ?
                                    sanitizeValue(filteredEmployeeInformation[0].Location).toString() 
                                    :
                                    ""
                                : 
                                "",
                        dateEmployed: filteredEmployeeInformation[0].DateEmployed ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateEmployed)) : null,
                        dateRegular: filteredEmployeeInformation[0].DateRegular ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateRegular)) : null,
                        dateProbationary: filteredEmployeeInformation[0].DateProbationary ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateProbationary)) : null,
                        dateResigned: filteredEmployeeInformation[0].DateResigned ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateResigned)) : null,
                        dateProjectBase: filteredEmployeeInformation[0].DateProjectBase ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateProjectBase)) : null,
                        dateContractual: filteredEmployeeInformation[0].DateContractual ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].DateContractual)) : null,
                        employmentDuration: filteredEmployeeInformation[0].EmploymentDuration ? convertToDateTimeLocal(sanitizeValueToNull(filteredEmployeeInformation[0].EmploymentDuration)) : null,
                        employment: filteredEmployeeInformation[0].Employment ? 
                                    foundEmployment ?
                                        sanitizeValue(filteredEmployeeInformation[0].Employment).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        department: filteredEmployeeInformation[0].Department ? 
                                    foundDepartment ?
                                        sanitizeValue(filteredEmployeeInformation[0].Department).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        section: filteredEmployeeInformation[0].Section ? 
                                foundSection ?
                                    sanitizeValue(filteredEmployeeInformation[0].Section).toString() 
                                    :
                                    ""
                                : 
                                "",
                        classification: filteredEmployeeInformation[0].Classification ? 
                                    foundClassification ?
                                        sanitizeValue(filteredEmployeeInformation[0].Classification).toString() 
                                        :
                                        ""
                                    : 
                                    "",
                        payType: filteredEmployeeInformation[0].PayType ? 
                                foundPaytype ?
                                    sanitizeValue(filteredEmployeeInformation[0].PayType).toString() 
                                    :
                                    ""
                                : 
                                "",
                        shiftSchedule: filteredEmployeeInformation[0].ShiftSchedule ? 
                                    foundShiftSchedule ?
                                        sanitizeValueIntType(filteredEmployeeInformation[0].ShiftSchedule).toString() 
                                        :
                                        null
                                    : 
                                    null,
                        position: filteredEmployeeInformation[0].Position ? 
                                foundPosition ?
                                    sanitizeValue(filteredEmployeeInformation[0].Position).toString() 
                                    :
                                    ""
                                : 
                                "",
                        company: filteredEmployeeInformation[0].Company ? 
                            foundCompany ?
                                sanitizeValue(filteredEmployeeInformation[0].Company).toString() 
                                :
                                ""
                            : 
                            "",
                        salaryType: filteredEmployeeInformation[0].SalaryType ? 
                            foundSalaryType ?
                                sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() === "Position - Designation" || sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() === "Position-Designation" ?
                                "PositionDesignation"
                                :
                                sanitizeValue(filteredEmployeeInformation[0].SalaryType).toString() 
                                    :
                                    ""
                            : 
                            "",
                        createdDate: new Date(),
                        createdBy: 0,
                    } : null,
                    employeeAccountInformation: filteredAccountInformation[0] ? {
                        employeeId: sanitizeValue(filteredAccountInformation[0].EmployeeId).toString(),
                        sss: sanitizeValue(filteredAccountInformation[0].Sss).toString(),
                        tin: sanitizeValue(filteredAccountInformation[0].Tin).toString(),
                        passport: sanitizeValue(filteredAccountInformation[0].Passport).toString(),
                        philhealth: sanitizeValue(filteredAccountInformation[0].Philhealth).toString(),
                        pagibig: sanitizeValue(filteredAccountInformation[0].Pagibig).toString(),
                    } : null,
                    employeeBankAccount: filteredBankAccount ? filteredBankAccount.map(bank => ({
                        employeeId: sanitizeValue(bank.EmployeeId).toString(),
                        bankAccount: sanitizeValue(bank.BankAccount).toString(),
                        bankName: sanitizeValue(bank.BankName),
                    })) : [],
                    employeeSalary: filteredSalary[0] ? {
                        employeeId: sanitizeValue(filteredSalary[0].EmployeeId).toString(),
                        salary: sanitizeValueIntType(filteredSalary[0].Salary).toString(),
                        allowance: sanitizeValueIntType(filteredSalary[0].Allowance).toString()
                    } : null,
                    employeeEducationAttainments: filteredBankAccount ? filteredEducationAttainments.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        level: sanitizeValue(data.Level),
                        schoolName: sanitizeValue(data.SchoolName),
                        address: sanitizeValue(data.Address),
                        dateFrom: data.DateFrom ? convertToDateTimeLocal(sanitizeValueToNull(data.DateFrom)) : null,
                        dateTo: data.DateTo ? convertToDateTimeLocal(sanitizeValueToNull(data.DateTo)) : null,
                        course: sanitizeValue(data.Course),
                        honors: sanitizeValue(data.Honors),
                    })) : [],
                    employeeDependents: filteredDependents ? filteredDependents.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        lastName: sanitizeValue(data.LastName),
                        firstName: sanitizeValue(data.FirstName),
                        middleName: sanitizeValue(data.MiddleName),
                        extensionName: sanitizeValue(data.ExtensionName),
                        dateOfBirth: data.DateOfBirth ? convertToDateTimeLocal(sanitizeValueToNull(data.DateOfBirth)) : null,
                        gender: sanitizeValue(data.Gender),
                        civilStatus: sanitizeValue(data.CivilStatus),
                    })) : [],
                    employeeFamilyData: filteredFamilyData ? filteredFamilyData.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        name: sanitizeValue(data.Name),
                        dateOfBirth: data.DateOfBirth ? convertToDateTimeLocal(sanitizeValueToNull(data.DateOfBirth)) : null,
                        occupation: sanitizeValue(data.Occupation),
                        contactNumber: sanitizeValue(data.ContactNumber).toString(),
                        age: sanitizeValueIntType(data.Age),
                        address: sanitizeValue(data.Address),
                        relationship: sanitizeValue(data.Relationship),
                    })) : [],
                    employeeEmergencyContacts: filteredEmergencyContacts ? filteredEmergencyContacts.map(data => ({
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        name: sanitizeValue(data.Name),
                        relationship: sanitizeValue(data.relationship),
                        contactNumber: sanitizeValue(data.ContactNumber).toString(),
                        address: sanitizeValue(data.Address),
                    })) : [],
                    employeeLeave: filteredEmployeeLeaves[0] ? {
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        totalVacation: sanitizeValueIntType(data.VacationLeave),
                        totalSick: sanitizeValueIntType(data.SickLeave),
                        totalServiceIncentive: sanitizeValueIntType(data.ServiceIncentiveLeave),
                        totalSoloParent: sanitizeValueIntType(data.SoloParentLeave),
                        vacationRemaining: sanitizeValueIntType(data.VacationLeaveRemaining),
                        sickRemaining: sanitizeValueIntType(data.SickLeaveRemaining),
                        serviceIncentiveRemaining: sanitizeValueIntType(data.ServiceIncentiveLeaveRemaining),
                        soloParentRemaining: sanitizeValueIntType(data.SoloParentLeaveRemaining),
                    } : null,
                    employeeStatuses: filteredEmployeeStatus[0] ? {
                        employeeId: sanitizeValue(data.EmployeeId).toString(),
                        status: data.EmployeeStatus ? sanitizeValue(data.EmployeeStatus) : "Active",
                    } : null,
                    employeeLeaveInformation: filteredEmployeeLeaveInformation 
                        ? filteredEmployeeLeaveInformation.map(data => ({
                                employeeId: sanitizeValue(data.EmployeeId).toString(),
                                leaveTypeId: dataLeaveTypes.find(i => i.description === data.LeaveType)?.id,
                                initialValue: sanitizeValueIntType(data.InitialValue),
                                remainingValue: sanitizeValueIntType(data.RemainingValue),
                                q1Value: sanitizeValueIntType(data["Q1Value(Jan-Mar)"]),
                                q2Value: sanitizeValueIntType(data["Q2Value(Apr-Jun)"]),
                                q3Value: sanitizeValueIntType(data["Q3Value(Jul-Sep)"]),
                                q4Value: sanitizeValueIntType(data["Q4Value(Oct-Dec)"]),
                            })) 
                        : [],
                });
            });
    
            const apiUrl = `${domain}/api/Employee/update-masterlist`;

            console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            try {
                const response = await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                console.log('Upload successful:', response.data);

                //await createAccountBulk(bulkData);

                await SetAuditTrail({
                    setupArea: "Employee List", 
                    actionTaken: "insert", 
                    field: "Upload Employee/s", 
                    newValue: "-", 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });
                await fetchDataBasicInfo();
                
                setRequestMessage('Upload successful');
                setShowRequestMessage(true);
                setIsSuccess(true);
            } catch (error) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                console.error('Error:', error);
                const errorResponse = JSON.parse(error.response.request.responseText);
                if (errorResponse.errors) {
                    // Get the first validation error message
                    const firstErrorKey = Object.keys(errorResponse.errors)[0]; // e.g., "[0].EmployeeInformation"
                    const errorMessage = errorResponse.errors[firstErrorKey][0]; // "The EmployeeInformation field is required."
        
                    setRequestMessage(errorMessage);
                } else {
                    setRequestMessage("An unknown error occurred.");
                }
            } finally {
                setLoadingRequest(false);
            }
        };
    
        reader.readAsArrayBuffer(file);
    };
    
    function handleFileUdateMasterlist(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        updateMasterlistData(file);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Employees List"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Employees List</h3>
                                <div style={{width:"30%",textAlign:"right"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            generateDownloadTemplate={generateDownloadTemplate}
                                            generateDownloadMasterlist={generateDownloadMasterlist}
                                            generateDownloadForBulkUpdateTemplate={generateDownloadForBulkUpdateTemplate}
                                            generateDownloadEmployeeInformation={generateDownloadEmployeeInformation}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            openUploadForBulkUpdateEmployeeInformationFormHandleClick={openUploadForBulkUpdateEmployeeInformationFormHandleClick}
                                            openUpdateMasterlistFormHandleClick={openUpdateMasterlistFormHandleClick}
                                            openBiometricsListFormHandleClick={openBiometricsListFormHandleClick}
                                            generateDownloadLeaveTemplate={generateDownloadLeaveTemplate}
                                            openUploadLeaveFormHandleClick={openUploadLeaveFormHandleClick}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body">
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Employee Status</div>
                                        <div className="info-item-input">
                                            <EmployeeStatus employeeStatus={employeeStatus} setEmployeeStatus={setEmployeeStatus} isEditMode={true}/>
                                        </div>
                                    </div>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Classification Type</div>
                                        <div className="info-item-input">
                                            <ClassificationFilter1 classificationId={classificationFilter} setClassificationId={setClassificationFilter} setActiveRowIds={setActiveRowIds} setSelectedEmployee={setSelectedEmployee}/>
                                        </div>
                                    </div>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Location</div>
                                        <div className="info-item-input">
                                            <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Filter</div>
                                        <div className="info-item-input">
                                            {Filter(setFilterDataIndex, setActiveRowIds, setSelectedEmployee)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="body-top employee-body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilter(e.target.value), 
                                                                        "Search by " + searchPlaceholder, 
                                                                        SearchIcon)}
                                </div>
                            </div>
                            <div className="body-top-btn row">
                                {CreateButton("", "add row", addHandleClick, "ADD EMPLOYEE", PeopleAltIcon)}
                                <div style={{display: "none"}}>
                                    {CreateButton("", "approve row", handleUpdate, "APPROVE", DoneIcon)}
                                    {CreateButton("", "approve row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
                                </div>
                            </div>
                            <div className='employeesTab-tab'>
                                <div id="container1" className="employeesTab-table container">
                                    <CreateTable
                                        dataList={employees}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        editHandleClick={viewEmployeeHandleClick}
                                        setSelectedEmployee={setSelectedEmployee}
                                        employees={employees}
                                        selectedToApprove={selectedToApprove}
                                        setSelectedToApprove={setSelectedToApprove}
                                        activeRowIds={activeRowIds}
                                        setActiveRowIds={setActiveRowIds}
                                        isSelectAll={isSelectAll}
                                        setIsSelectAll={setIsSelectAll}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <UploadForBulkUpdateForm  isOpen={showUploadForBulkUpdateForm} 
                    onClose={closeUploadForBulkUpdateEmployeeInformationFormHandleClick}
                    handleFileUpload={handleFileUploadForBulkUpdate}
            >
            </UploadForBulkUpdateForm>
            <UpdateMasterlistForm  isOpen={showUpdateMasterlistForm} 
                    onClose={closeUpdateMasterlistFormHandleClick}
                    handleFileUpload={handleFileUdateMasterlist}
            >
            </UpdateMasterlistForm>
            <UploadLeaveForm  isOpen={showUploadLeaveUpdateForm} 
                    onClose={closeUploadLeaveFormHandleClick}
                    handleFileUpload={handleFileUploadLeave}
            >
            </UploadLeaveForm>
            {   showBiometricsListForm &&
                <BiometricsList  isOpen={showBiometricsListForm} 
                        onClose={closeBiometricsListFormHandleClick}
                        employees={employees}
                        fetchDataBasicInfo={fetchDataBasicInfo}
                        user={user}
                >
                </BiometricsList>
            }
            { showViewEmployee &&
                <ViewEmployee   user={user}
                                isOpen={showViewEmployee}
                                onClose={closeViewEmployeeHandleClick}
                                viewedData={viewedData}
                                setViewedData={setViewedData}
                                fetchData={fetchDataBasicInfo}
                                employeePhoto={employeePhoto}
                                setEmployeePhoto={setEmployeePhoto}
                />
            }
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <GenerateWarningMessage form={showRequestWarningMessage}
                    message={requestWarningMessage}
            > 
            </GenerateWarningMessage>
            {loadingRequest || loading ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function SettingInit({
    generateDownloadTemplate,
    generateDownloadMasterlist,
    generateDownloadForBulkUpdateTemplate,
    generateDownloadEmployeeInformation,
    openUploadForBulkUpdateEmployeeInformationFormHandleClick,
    openUpdateMasterlistFormHandleClick,
    openUploadFormHandleClick,
    openBiometricsListFormHandleClick,
    generateDownloadLeaveTemplate,
    openUploadLeaveFormHandleClick,
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div style={{
                textAlign: "center",
                margin: "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px"
            }}
            >
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
                <span>Download Informations</span>
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadEmployeeInformation(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#29aec5"}}><FileOpenIcon/></div>
                Download Employee Information
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadMasterlist(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#29aec5"}}><FileOpenIcon/></div>
                Download Masterlist
            </div>




            <div style={{
                textAlign: "center",
                margin: "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                marginTop: "40px"
            }}
            >
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
                <span>Register Employee/s</span>
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Employee/s
            </div>
            <div className="payroll-setting-item row"onClick={()=>openBiometricsListFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ffaa00"}}><GroupsIcon/></div>
                Create Employee/s From Biometrics
            </div>

            <div style={{
                textAlign: "center",
                margin: "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                marginTop: "40px"
            }}
            >
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
                <span>Update Employee's Informations</span>
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadForBulkUpdateTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Employee Information Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadForBulkUpdateEmployeeInformationFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload For Bulk Update Employee Information
            </div>
            <div className="payroll-setting-item row hidden"onClick={()=>openUpdateMasterlistFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Update Masterlist
            </div>

            <div style={{
                textAlign: "center",
                margin: "10px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                marginTop: "40px"
            }}
            >
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
                <span>Update Employee's Leave</span>
                <span style={{borderBottom: "1px solid gray", width: "40px"}}></span>
            </div>
            <div className="payroll-setting-item row" onClick={()=>generateDownloadLeaveTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Employee Leave Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadLeaveFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Employee/s Leave
            </div>
        </div>
    )
}
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Employee/s"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function UploadLeaveForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Employee/s Leave"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function UploadForBulkUpdateForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload For Update Bulk Employee Information"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>clearFiles()}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function UpdateMasterlistForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };


    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Update Masterlist"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>clearFiles()}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
}
function BiometricsList({isOpen, 
    onClose,
    employees,
    fetchDataBasicInfo,
    user
}
){
    var header = [
        "Employee Id",
        "Full Name",
        "",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesFromBio, setEmployeesFromBio] = useState([]);
    const [selectedToAdd, setSelectedToAdd] = useState([]);
    const [dataToAdd, setDataToAdd] = useState([]);
    const [nonExistingDataFromBio, setNonExistingDataFromBio] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [addConfirmation, setAddConfirmation] = useState(false);
    const [addConfirmationBulk, setAddConfirmationBulk] = useState(false);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    // const fetchDataAccessTemplate =  useCallback(async () => {
    //     const apiUrl =  domain + "/api/AccessTemplate";

    //         try {
    //             setLoading(true);
    //             const response = await axios.get(apiUrl , {
    //                 headers: {
    //                     'Authorization': `Bearer ${token}`,
    //                     'Content-Type': 'application/json' // You can include other headers if needed
    //             }})
    //             return response.data;
    //         } catch (error) {
    //         console.error('Error fetching data:', error);
    //         return [];
    //     }
    //     }, []);
    // const fetchDataEmployeeInfoForMasterlist = useCallback(async () => {
    //     const apiUrl =  domain + "/api/Employee/masterlist";

    //     try {
    //         const response = await axios.get(apiUrl, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Content-Type': 'application/json'
    //         }})
    //             return response.data;
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         return []
    //     }
    // }, []);
    // const fetchDataAccounts = useCallback(async () => {
    //     const apiUrl =  domain + "/api/Authentication";

    //     try {
    //         setLoading(true);
    //         const response = await axios.get(apiUrl , {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Content-Type': 'application/json' // You can include other headers if needed
    //         }})
    //         return response.data; 
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         return []
    //     }
    // }, []);

    // const createAccount = async (employee) => {
    //     const accessTemplate = await fetchDataAccessTemplate();
    //     const employeeInfo = await fetchDataEmployeeInfoForMasterlist();
    //     const accounts = await fetchDataAccounts();

    //     const foundTemplate = accessTemplate.find(data => 
    //         data.description.toLowerCase() === ("Employee").toLowerCase()
    //     );
    //     const foundEmployee = employeeInfo.find(data => 
    //         data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
    //     );

    //     function generateUniqueUsernames(employee, existingUsernames) {
    //         const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
    //         const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
    //         let baseUsername = firstNameInitial + lastNameLower;
        
    //         let uniqueUsername = baseUsername;
    //         let counter = 1;
        
    //         while (existingUsernames.includes(uniqueUsername)) {
    //             uniqueUsername = `${baseUsername}${counter}`;
    //             counter += 1;
    //         }
        
    //         existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
    //         return uniqueUsername;
    //     }
        
    //     const apiUrl =  domain + "/api/Authentication";

    //     const existingUsernames = [];

    //     accounts.forEach(employee => {
    //         existingUsernames.push(employee.username);
    //     });

    //     const username = generateUniqueUsernames(employee, existingUsernames);
    //     existingUsernames.push(username);

    //     const data = {
    //         username: username,
    //         password: "password",
    //         employeePersonalInformationId: foundEmployee.id,
    //         accessTemplateId: foundTemplate.id
    //     };

    //     try {
    //         axios.post(apiUrl + `/register`, data, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Content-Type': 'application/json'
    //             }
    //         });
            
    //     } catch (error) {
    //         setShowRequestMessage(true);
    //         setIsSuccess(false);
    //         console.error('Error:', error);
    //         const errorMessage = JSON.parse(error.response.request.responseText).message;
    //         setRequestMessage(errorMessage);
    //     }
    // }
    // const createAccountBulk = async (bulkData) => {
    //     const accessTemplate = await fetchDataAccessTemplate();
    //     const accounts = await fetchDataAccounts();
    //     const employeeInfo = await fetchDataEmployeeInfoForMasterlist();

    //     const foundTemplate = accessTemplate.find(data => 
    //         data.description.toLowerCase() === ("Employee").toLowerCase()
    //     );

    //     function generateUniqueUsernames(employee, existingUsernames) {
    //         const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
    //         const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
    //         let baseUsername = firstNameInitial + lastNameLower;
        
    //         let uniqueUsername = baseUsername;
    //         let counter = 1;
        
    //         while (existingUsernames.includes(uniqueUsername)) {
    //             uniqueUsername = `${baseUsername}${counter}`;
    //             counter += 1;
    //         }
        
    //         existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
    //         return uniqueUsername;
    //     }
        
    //     const apiUrl =  domain + "/api/Authentication";

    //     const existingUsernames = [];
    //     const dataToAdd = [];

    //     for(const employee of bulkData){
    //         const foundEmployee = employeeInfo.find(data => 
    //             data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
    //         );

    //         accounts.forEach(employee => {
    //             existingUsernames.push(employee.username);
    //         });
    
    //         const username = generateUniqueUsernames(employee, existingUsernames);
    //         existingUsernames.push(username);
    
    //         const data = {
    //             username: username,
    //             password: "password",
    //             employeePersonalInformationId: foundEmployee.id,
    //             accessTemplateId: foundTemplate.id
    //         };

    //         dataToAdd.push(data)
    //     }

    //     try {
    //         axios.post(apiUrl + `/register/bulk`, dataToAdd, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Content-Type': 'application/json'
    //             }
    //         });
            
    //     } catch (error) {
    //         setShowRequestMessage(true);
    //         setIsSuccess(false);
    //         console.error('Error:', error);
    //         const errorMessage = JSON.parse(error.response.request.responseText).message;
    //         setRequestMessage(errorMessage);
    //     }
    // }
    
    const handleClose = () => {
        onClose();
        setSelectedToAdd([]);
        setIsSelectAll(false);
        setFilterDataIndex(0);
    };

    const closeConfirmationHandleClick = () =>{
        setAddConfirmation(false);
    }
    const closeConfirmationBulkHandleClick = () =>{
        setAddConfirmationBulk(false);
    }

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/biometrics-employees";
        setLoading(true);

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})

            console.log(response.data)

            const nonExistingData = response.data.filter(responseEmployee => 
                !employees.some(employee => employee.employeeId.trim() === responseEmployee.employeeId.trim())
            );

            setNonExistingDataFromBio(nonExistingData);

            if(filterDataIndex === 2){ // filter existing
                const existingData = response.data.filter(responseEmployee => 
                    employees.some(employee => employee.employeeId.trim() === responseEmployee.employeeId.trim())
                );

                setEmployeesFromBio(existingData);
                setFilterData(existingData);
            } else if(filterDataIndex === 3){ // filter non existing
                setEmployeesFromBio(nonExistingData);
                setFilterData(nonExistingData);
            } else {
                setEmployeesFromBio(response.data);
                setFilterData(response.data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [employees, filterDataIndex]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const apiUrl =  domain + "/api/Employee";

        const data = {
            employeeId: dataToAdd.employeeId.trim(),
            lastName: dataToAdd.lastName,
            firstName: dataToAdd.firstName,
            fullName: dataToAdd.fullName,
            middleName: "",
            extensionName: "",
            nickName: "",
            age: null,
            dateOfBirth: null,
            placeOfBirth: "",
            civilStatus: "",
            bloodType: "",
            height: "",
            weight: "",
            citizenship: "",
            religion: "",
            gender: "",
            mobileNumber: "",
            emailAddress: "",
            blkLot: "",
            street: "",
            barangay: "",
            city: "",
            postalCode: "",
            yearsOfStay: null,
            photo: "",
            deviceNumber: "",
            employeeInformation: {
                employeePersonalInformationId: 0,
                locationId: 1,
                dateEmployed: null,
                dateRegular: null,
                dateProbationary: null,
                dateProjectBase: null,
                dateContractual: null,
                employmentDuration: null,
                employmentId: 1,
                departmentId: 1,
                sectionId: 1,
                classificationId: 1,
                payTypeId: 1,
                shiftScheduleId: 1,
                positionId: 1,
                companyId: 1,
                salaryType: "",
                createdDate: new Date(),
                createdBy: 0,
                updatedDate: null,
                updatedBy: 0
            },
            employeeStatuses: {
                // employeePersonalInformationId: employeeId,
                status: "Active",
            },
            /* employeeReportTo: {
                employeePersonalInformationId: 0,
                reportToId: null
            },
            employeeAccountInformation: {
                employeePersonalInformationId: 0,
                sss: "",
                tin: "",
                passport: "",
                philhealth: "",
                pagibig: "",
                primaryBankAccountId: null
            },
            employeeBankAccount: [
                {
                employeePersonalInformationId: 0,
                employeePersonalInformationEmployeeId: "",
                bankAccount: "",
                bankName: ""
                }
            ],
            employeeSalary: {
                employeePersonalInformationId: 0,
                salary: "",
                allowance: ""
            },
            employeeRestDays: [
                {
                employeePersonalInformationId: 0,
                day: ""
                }
            ],
            employeeEducationAttainments: [
                {
                employeePersonalInformationId: 0,
                level: "",
                schoolName: "",
                address: "",
                dateFrom: null,
                dateTo: null,
                course: "",
                honors: ""
                }
            ],
            employeeDependents: [
                {
                employeePersonalInformationId: 0,
                lastName: "",
                firstName: "",
                middleName: "",
                extensionName: "",
                dateOfBirth: null,
                gender: "",
                civilStatus: ""
                }
            ],
            employeeFamilyData: [
                {
                employeePersonalInformationId: 0,
                name: "",
                dateOfBirth: null,
                occupation: "",
                contactNumber: "",
                age: null,
                address: "",
                relationship: ""
                }
            ],
            employeeEmergencyContacts: [
                {
                    employeePersonalInformationId: 0,
                    name: "",
                    relationship: "",
                    contactNumber: "",
                    address: ""
                }
            ] */
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "insert", 
                field: "Create Employee/s From Biometrics", 
                newValue: data.fullName, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            setAddConfirmation(false);

            await fetchData();
            // await createAccount(data);
            await fetchDataBasicInfo();
            
            setShowRequestMessage(true);
            setIsSuccess(true);
            setIsAdd(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setAddConfirmation(false);
    };
    const handleSubmitBulk = async (event) => {
        event.preventDefault();

        setLoadingRequest(true);
    
        const apiUrl = domain + "/api/Employee/bulk";
    
        // Remove duplicates based on employeeId
        const uniqueSelectedToAdd = Array.from(new Set(selectedToAdd.map(data => data.employeeId)))
            .map(id => {
                return selectedToAdd.find(data => data.employeeId === id);
            });
    
        const bulkData = uniqueSelectedToAdd
        .filter(data => data.employeeId.length <= 20)  // Only include employeeId with 20 characters or fewer
        .map(data => ({
            employeeId: data.employeeId.trim(),
            lastName: data.lastName,
            firstName: data.firstName,
            fullName: data.fullName,
            employeeInformation: {
                employeePersonalInformationId: 0,
                locationId: 1,
                dateEmployed: null,
                dateRegular: null,
                dateProbationary: null,
                dateProjectBase: null,
                dateContractual: null,
                employmentDuration: null,
                employmentId: 1,
                departmentId: 1,
                sectionId: 1,
                classificationId: 1,
                payTypeId: 1,
                shiftScheduleId: 1,
                positionId: 1,
                companyId: 1,
                salaryType: "",
                createdDate: new Date(),
                createdBy: 0,
                updatedDate: null,
                updatedBy: 0
            },
            employeeStatuses: {
                status: "Active",
            },
        }));

        // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
        try {
            await axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await SetAuditTrail({
                setupArea: "Employee List", 
                actionTaken: "insert", 
                field: "Create Employee/s From Biometrics", 
                newValue: "[bulk data]", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            setAddConfirmationBulk(false);
            
            await fetchData();
            await fetchDataBasicInfo();
            
            // await createAccountBulk(bulkData);
            
            setIsSelectAll(false);
            setSelectedToAdd([]);
            setIsAdd(true);
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    
        setAddConfirmationBulk(false);
    };
    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 3:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployeesFromBio(res);
    };

    const selectAllHandler = () =>{
        if(isSelectAll){
            setIsSelectAll(false);
        } else {
            setIsSelectAll(true);
        }
    }

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            case 2:
                setSearchPlaceholder("Search by name")
                break;
            case 3:
                setSearchPlaceholder("Search by name")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
    }, [fetchData, filterDataIndex]);

    useEffect(() => {
        if(isSelectAll){
            setSelectedToAdd(nonExistingDataFromBio);
        } else {
            setSelectedToAdd([]);
        }
    }, [isSelectAll, nonExistingDataFromBio]);

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Employee's List from Biometrics"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                        <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                        <div className="transaction-body-top row">
                            {CreateSearchBarWithPlaceHolder("", 
                                                            "transaction-search row", 
                                                            "transaction-search-icon", 
                                                            "transaction-search-input", 
                                                            (e)=>handleFilter(e.target.value), 
                                                            searchPlaceholder,
                                                            SearchIcon)}
                            
                        </div>
                        <div className="transaction-body-top row">
                            <div style={{margin:"0 5px"}}>
                                <button className='select' onClick={selectAllHandler}>
                                    { isSelectAll ? "UNSELECT ALL" : "SELECT ALL"}
                                </button>
                            </div>
                            <div  style={{margin:"0 5px"}}>
                                <button className={`${selectedToAdd.length > 0 ? "add" : "add-disabled"}` } 
                                    disabled={selectedToAdd.length > 0 ? false : true}
                                    onClick={()=>setAddConfirmationBulk(true)}>
                                    ADD ALL SELECTED
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="popUp-body biometrics-modal">
                        <div className="select-employee-table employee-list-table">
                            <CreateTableForEmployeesBiometrics
                                dataList={employeesFromBio}
                                dataHeader={header}
                                dataAccessor={accessor}
                                employees={employees}
                                setDataToAdd={setDataToAdd}
                                setAddConfirmation={setAddConfirmation}
                                selectedToAdd={selectedToAdd}
                                setSelectedToAdd={setSelectedToAdd}
                                isSelectAll={isSelectAll}
                                isAdd={isAdd}
                                setIsAdd={setIsAdd}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employeesFromBio.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            </div>
            <ConfirmationForm  isOpen={addConfirmation} 
                        onClose={closeConfirmationHandleClick}
                        handleConfirm={handleSubmit}
            >
            </ConfirmationForm>
            <ConfirmationBulkForm  isOpen={addConfirmationBulk} 
                        onClose={closeConfirmationBulkHandleClick}
                        handleConfirm={handleSubmitBulk}
            >
            </ConfirmationBulkForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            case "ExistingEmployee":
                setFilterDataIndex(2);
                break;
            case "NonExistingEmployee":
                setFilterDataIndex(3);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
                <option value="ExistingEmployee">Existing Employee</option>
                <option value="NonExistingEmployee">Non Existing Employee</option>
            </select>
        </div>
    );
};
function CreateTable({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    editHandleClick, 
    employees, 
    setSelectedEmployee,
    selectedToApprove,
    setSelectedToApprove, 
    currentPage, setCurrentPage,
    isSelectAll, setIsSelectAll, activeRowIds, setActiveRowIds
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    useEffect(()=>{
        if(isSelectAll){
            const newActiveRowIds = rows.map(item => item.original.id);
            const newActiveRowOriginal = rows.map(item => item.original);
            setActiveRowIds(newActiveRowIds);
            setSelectedEmployee(newActiveRowOriginal);
            setIsSelectAll(false);
        }
    }, [isSelectAll, setIsSelectAll, setSelectedEmployee, rows, setActiveRowIds])

    const handleRowClick = (rowData) => {
        setSelectedEmployee(prevSelected => {
            const isAlreadySelected = prevSelected.some(item => item.id === rowData.id);
            return isAlreadySelected
                ? prevSelected.filter(item => item.id !== rowData.id)  // Remove rowData if already selected
                : [...prevSelected, rowData];                         // Add rowData if not selected
        });
        setActiveRowIds(prevIds => 
            prevIds.includes(rowData.id) 
            ? prevIds.filter(id => id !== rowData.id)  // Remove the row ID if it is already active
            : [...prevIds, rowData.id]                 // Add the new row ID if it is not already active
        );
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            employees.length > 0 ?
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                                className={activeRowIds.includes(row.original.id) ? 'active' : ''}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        editHandleClick={editHandleClick}
                                        selectedToApprove={selectedToApprove}
                                        setSelectedToApprove={setSelectedToApprove}
                                        />
                                    ))}
                                </tr>
                            :
                                <></>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage && employees.length > 0 ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfo({header, 
    _cell, 
    editHandleClick,
    selectedToApprove,
    setSelectedToApprove
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    const [isChecked, setIsChecked] = useState(false);

    const handleItem = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            setSelectedToApprove(prevItems => [...prevItems, data]);
        } else {
            setSelectedToApprove(prevItems => prevItems.filter(i => i !== data));
        }
    };

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if (header === "Is Approved?") {
        if(value === "Approved"){
            return (
                <td>
                    <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={true}
                        disabled
                    />
                </td>
            )
        }

        if(!value){
            return (
                <td>
                    <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={isChecked}
                        onChange={handleItem}
                        disabled
                    />
                </td>
            )
        }

        return(
            <td>
                {_cell.render("Cell").props.value}
            </td>
        )
    }

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="View">
                    <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </TooltipManage>
                </div>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function CreateTableForEmployeesBiometrics({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [], 
    employees, 
    setDataToAdd, 
    setAddConfirmation, 
    selectedToAdd,
    setSelectedToAdd,
    isSelectAll,
    isAdd,
    setIsAdd,
    
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            employees.length > 0 ?
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForEmployeesBiometrics 
                                                header={cell.render("Cell").props.column.Header}
                                                _cell={cell}
                                                employees={employees}
                                                setDataToAdd={setDataToAdd}
                                                setAddConfirmation={setAddConfirmation}
                                                selectedToAdd={selectedToAdd}
                                                setSelectedToAdd={setSelectedToAdd}
                                                isSelectAll={isSelectAll}
                                                isAdd={isAdd}
                                                setIsAdd={setIsAdd}
                                        />
                                    ))}
                                </tr>
                            :
                                <></>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage && employees.length > 0 ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForEmployeesBiometrics({header, 
    _cell, 
    employees, 
    setDataToAdd, 
    setAddConfirmation,
    selectedToAdd,
    setSelectedToAdd,
    isSelectAll,
    isAdd,
    setIsAdd
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;
    
    const [isChecked, setIsChecked] = useState(false);
    
    useEffect(() => {
        setIsChecked(isSelectAll);
    }, [isSelectAll ]);

    useEffect(() => {
        if(isAdd){
            setIsChecked(false)
            setIsAdd(false)
        }
    }, [isAdd, setIsAdd]);

    const singleAdd = (selectedData) =>{
        setDataToAdd(selectedData);
        setAddConfirmation(true);
    }

    const handleItem = (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);

        if (checked) {
            setSelectedToAdd(prevItems => [...prevItems, data]);
        } else {
            setSelectedToAdd(prevItems => prevItems.filter(i => i !== data));
        }
    };

    if (header === "Photo") {
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if (header === "Status") {
        if(!value){
            return (
                <td>
                    Pending
                </td>
            )
        }

        return(
            <td>
                {_cell.render("Cell").props.value}
            </td>
        )
    }

    if (header === "") {
        const foundEmployee = employees.find(employee => {
            return employee.employeeId.toString().trim() === data.employeeId.toString().trim()
        })

        if(foundEmployee){
            return(
                <td></td>
            )
        }
        
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <TooltipManage text="Add">
                        <div style={{padding:"0 5px"}} onClick={()=>singleAdd(data)}><PersonAddAltIcon/></div>
                    </TooltipManage>
                    
                    <input type="checkbox" 
                        id="overtime-allowance" 
                        className="checkbox"
                        name="" 
                        checked={isChecked}
                        onChange={handleItem}
                    />
                </div>
                
            </td>
        )
    }

    if(header === "Date Created"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function Filter(setFilterDataIndex, setActiveRowIds, setSelectedEmployee){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            case "Approved":
                setFilterDataIndex(2);
                break;
            case "Pending":
                setFilterDataIndex(3);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }

        if(setActiveRowIds && setSelectedEmployee){
            setActiveRowIds([]);
            setSelectedEmployee([]);
        }
    };

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value="All">All</option>
            <option value="EmployeeId">Employee Id</option>
            <option value="Approved">Approved</option>
            <option value="Pending">Pending</option>
        </select>
    );
};
function ClassificationFilter1({classificationId, setClassificationId, setActiveRowIds, setSelectedEmployee}){
    const handleSelectChange = (event) => {
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedEmployee){
            setActiveRowIds([]);
            setSelectedEmployee([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl = domain + "/api/Classification/active";
        
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // Include other headers if needed
                }
            });

            setData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value={"0"}>All</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
        </select>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
const TooltipManage = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function ConfirmationForm({isOpen, 
    onClose, 
    handleConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to add this employee?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleConfirm}
                            style={{marginRight:"5px"}}>
                                ADD
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ConfirmationBulkForm({isOpen, 
    onClose, 
    handleConfirm}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Employee/s</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to add this employee?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleConfirm}
                            style={{marginRight:"5px"}}>
                                ADD
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeStatus({employeeStatus, setEmployeeStatus, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setEmployeeStatus(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/EmployeeStatusMaintenance/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(employeeStatus !== "" && employeeStatus !== 0){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [employeeStatus]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeStatus || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="All" >All</option>
          {data.map((employeeStatus) => ( 
            <option value={employeeStatus.description}>{
              employeeStatus.description}
            </option>
          ))}
          </select>
      </div>
  );
};
export default EmployeesList
